// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../src/Images/left-arrow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../src/Images/right-arrow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../src/Images/black-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,<svg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23ffffff%27><path fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./Images/right-arrow-white.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bs-font-sans-serif: Poppins;
}

body {
  font-family: var(--bs-font-sans-serif);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}

.gradient-heading-lg-blue {
  background: #4ecdff;
  background: linear-gradient(to right, #4ecdff 31%, #0075e2 55%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-family: "Poppins";
  font-size: 32px;
  font-weight: 600;
  text-align: center;
  margin: 0 0 20px 0;
}

.gradient-heading-lg-pink {
  background: #ff2a83;
  background: linear-gradient(to right, #ff2a83 31%, #9c0041 55%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-family: "Poppins", sans-serif;
  font-size: 32px;
  font-weight: 800;
  text-align: center;
  margin: 0 0 20px 0;
}

.gradient-heading-lg-dark {
  background: #333;
  background: linear-gradient(to right, #333 45%, #000 50%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-family: "Poppins", sans-serif;
  font-size: 32px;
  font-weight: 600;
  text-align: center;
  margin: 0 0 20px 0;
}

/* ..............header start............. */
header {
  padding: 15px 0;
  position: sticky;
  top: 0;
  z-index: 999;
  background: #fff;
  transition: all .3s ease-in-out;
}

header .navbar-brand img {
  width: 150px;
  margin: 0 auto;
}

.header .nav-item a {
  color: #000;
  font-size: 16px;
  font-weight: 500;
  text-decoration: none;
}

.header .nav-item {
  padding: 0 10px;
  white-space: nowrap;
}

.header .nav-item.active a {
  border-bottom: 3px solid #000;
}

header .navbar-toggler {
  border: none;
  padding: 1px 0;
  height: 30px;
  width: 35px;
  transition: all 0.3s ease-in-out;
}

@media screen and (max-width:992px) {
  .primary-menu-container {
    position: fixed;
    top: 85px;
    right: 0;
    left: 0;
    bottom: 0;
    background: #0a0b12;
    z-index: 9999;
    transition: all .2s ease-in-out;
    transform: translateX(100%);
  }

  .primary-menu-container .navbar-nav {
    padding: 30px 0;
  }

  .primary-menu-container .navbar-nav li a {
    display: block;
    padding: 10px 15px;
  }
}

@media screen and (max-width:992px) {


  .header .nav-item a {
    color: rgb(255, 255, 255);
  }

  header .navbar-toggler[aria-expanded=true] .navbar-toggler-icon {
    border-color: transparent;
  }

  .navbar-toggler[aria-expanded=true] .navbar-toggler-icon:before {
    transform: rotate(45deg)
  }

  .navbar-toggler[aria-expanded=true] .navbar-toggler-icon:after {
    transform: rotate(-45deg) translate(7px, -8px);
  }

  .header .navbar-toggler-icon {
    background-image: none;
    border-top: 3px solid #333;
    margin: 0;
    width: 21px;
    height: 21px;
    transition: all 0.3s ease-in-out;
    position: relative;
  }

  header .navbar-toggler .navbar-toggler-icon:before,
  header .navbar-toggler .navbar-toggler-icon:after {
    content: '';
    height: 3px;
    width: 100%;
    position: absolute;
    background: #333;
    left: 0;
    transition: all 0.3s ease-in-out;
  }

  header .navbar-toggler .navbar-toggler-icon:before {
    top: 5px;
  }

  header .navbar-toggler .navbar-toggler-icon:after {
    bottom: 0;
  }

}

@media screen and (max-width:992px) {
  .primary-menu-container {
    top: 70px;
  }

  .primary-menu-container.show {
    transition: all .2s ease-in-out;
    transform: translateX(0) !important;
  }
}

/* ..............banner-start.................... */
.banner-title {
  margin-bottom: 45px;
}

.banner-inner {
  padding: 50px 0;
  /* height: calc(100vh - 125px); */
  display: flex;
  align-items: center;
  justify-content: center;
}

.banner-title-text {
  text-align: center;
  font-weight: 800;
  color: black;
  font-size: 135px;
  line-height: 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* font-family: Poppins; */
}

@media (max-width: 1229px) {
  .banner-title-text {
    font-size: 85px;
    line-height: 100px;
  }
}

@media (max-width: 767px) {
  .banner-title-text {
    line-height: 13.5vw;
    font-size: 13.5vw;
  }

  .footer-list-wrapper {
    width: 100%;
  }
}

.banner-button-inner {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 45px;
}

.building-btn {
  background-color: rgb(0, 0, 0);
  padding: 15px 35px;
  color: rgb(255, 255, 255);
  border-radius: 6px;
  text-decoration: none;
  cursor: pointer;
  border: 1px solid rgb(0, 0, 0);
  margin: 0 10px;
  min-width: 180px;
}

.building-btn:last-child {
  background-color: rgb(255, 255, 255);
  color: rgb(0, 0, 0);
}

.building-btn:hover {
  background-color: rgb(255, 255, 255);
  color: rgb(0, 0, 0);
}

.banner-description-text {
  font-size: 18px;
  font-weight: 400;
  color: #000;
  font-family: Poppins;
  letter-spacing: 0.2px;
  margin: 0 auto;
  padding: 0;
  text-align: center;
  max-width: 700px;
  line-height: normal;
}

/* ........................banner-end................. */

/* ....................banner-section-2 start............. */
.buildpan-icon {
  background-color: #000;
}

.buildpanicon_main_wrapper {
  padding: 60px 0 40px;
}

.buildpanicon_main_wrapper h2 {
  text-align: center;
  font-size: 16px;
  line-height: normal;
  font-weight: 400;
  margin: 0 auto 50px;
  padding: 0;
  color: #fff;
  width: 500px;
  max-width: 100%;
  font-family: "Poppins";
}

.buildpan-icons-wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.buildpan_icons_inner {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  border: 1px dashed #3e3e3e;
  background: #0c0c0c;
  border-radius: 20px;
  padding: 14px;
  transform: scale(1);
  transition: all 0.3s ease-in-out;
}

.buildpan_icons_inner:hover {
  border: 1px dashed #707070;
  background: #202020;
  box-shadow: 0 0 15px #1c293a;
  background: #000;
  transform: scale(1.1);
}

.buildpan_icon {
  max-width: 120px;
  margin-bottom: 20px;
  object-fit: contain;
  width: 100%;
}

.buildpan_icon_text {
  font-size: 17px;
  font-weight: 400;
  text-align: center;
  color: #fff;
  letter-spacing: 0.2px;
  margin: 0;
}

.buildpan-card {
  margin-bottom: 30px;
}

/* ........................banner-section2 end................... */

/* .................................banner-section-3 start.................. */
.ship-section-stats {
  border-top: 1px solid rgb(233 233 233 / 80%);
  border-bottom: 1px solid rgb(233 233 233 / 80%);
  background-color: rgba(246, 246, 246, 0.799);
  padding: 50px 0;
}

.ship-section-wrapper {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.ship-section-wrapper-item {
  border-right: 1px solid #eaeaea;
  padding: 0 0px;
  text-align: center;
  width: 25%;
}

.ship-section-wrapper-item:last-child {
  border-right: none;
}

.ship-section-wrapper-item .highlight {
  font-size: 54px;
  font-family: Poppins;
  font-weight: 600;
  margin: 0;
  color: #000;
}

.ship-section-wrapper-item .description {
  font-size: 17px;
  font-family: Poppins;
  color: #000;
}

.ship-section-wrapper-item .meetourteam {
  text-align: center;
  margin-bottom: 30px;
  font-size: 32px;
}

/* .................................banner-section-3 end.................. */

/* ...........................banner-section-4-start...................... */

.customer-logos {
  padding-top: 30px;
}

.customer-logos img {
  width: 100%;
  height: 100px;
  object-fit: contain;
  margin: 0 auto;
}

.our-clients {
  background-color: #fff;
  border-bottom: 1px solid rgb(206 206 206 / 80%);
  padding: 60px 0;
}

/* ...........................banner-section-4-end...................... */

/* ....................................testimonials............................................. */

.testimonials .slick-slide {
  display: flex !important;
  align-items: center;
  justify-content: center;
  height: inherit;
}

.testimonials .slick-dots {
  position: relative;
}

.testimonials .slick-track {
  transition: all 0.3s ease-in-out;
}

.testimonials .mySlides-para {
  font-size: 18px;
  font-weight: 400;
  max-width: 600px;
  font-family: Poppins;
  margin-bottom: 30px;
}

.testimonials .text-bold {
  font-size: 18px;
  font-weight: 500;
}

.testimonials {
  margin: 60px 0 60px;
}

.testimonials_heading {
  text-align: center;
  font-size: 35px;
  margin: 0;
}

.testimonials .slick-prev:before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
  background-repeat: no-repeat;
  color: rgba(0, 0, 0, 0);
  font-size: 42px;
  left: 0;
  position: absolute;
}

.testimonials .slick-next:before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) !important;
  background-repeat: no-repeat;
  color: rgba(0, 0, 0, 0);
  font-size: 42px;
  right: 0;
  position: absolute;
}

.testimonials .slick-prev {
  left: 0 !important;
}

.testimonials .slick-next {
  right: 0 !important;
}

.testimonials .slick-slider {
  padding: 0 50px;
  text-align: center;
  background: #fff;
}

/* ................testimonials-end-------------------------- */

/* .......................footer-start.......................... */
.footer {
  padding: 45px 0;
  background-color: #000;
}

.footer .bugfree {
  margin-bottom: 40px;
  border-bottom: 1px dashed #3e3e3e;
  padding-bottom: 35px;
}

.footer .bugfree-inner {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.footer .bugfree-text {
  padding: 0 15px;
  font-size: 22px;
  color: #fff;
  font-family: sans-serif;
}

.footer .bugfree-text span {
  font-weight: 600;
}

.footer .Start-btn {
  padding: 12px 24px;
  color: white;
  border: 1px solid #fff;
  border-radius: 50px;
  margin-right: 15px;
  text-decoration: none;
}

.footer .Start-btn:hover {
  color: white;
  text-decoration: none;
}

.footer .Request-demo {
  padding: 12px 24px;
  background-color: #fff;
  color: black;
  border-radius: 50px;
  text-decoration: none;
  font-size: 17px;
}

.footer .Request-demo:hover {
  color: rgb(255, 255, 255);
  color: black;
  text-decoration: none;
}

.footer .footer-inner {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.footer .Workflow-wrapper {
  width: 55%;
}

.footer .Workflow-heading {
  font-size: 26px;
  color: #fff;
  margin-bottom: 20px;
}

.footer .Workflow-para {
  font-size: 15px;
  color: #fff;
  line-height: 27px;
}

.footer .Workflow-para a {
  color: #4ecdff;
}

.footer .footer-list a {
  font-size: 15px;
  color: #e5e5e5;
  cursor: pointer;
  line-height: 30px;
  white-space: nowrap;
  text-decoration: none;
}

.footer .footer-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer .footer-list a:hover {
  color: #e5e5e5;
  text-decoration: none;
}

.footer .social-list a {
  width: 32px;
  height: 32px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  text-decoration: none;
  margin: 0 8px 0 0;
}

.footer .social-list a img {
  width: 20px;
  height: 20px;
}

.footer .social-list a i {
  font-size: 14px;
  color: #fff;
}

.footer .facebook-bg {
  background: #4267b2;
}

.footer .twitter-bg {
  background: #1da1f2;
}

.footer .instagram-bg {
  background: #e4405f;
}

.footer .linkedin-bg {
  background: #0072b1;
}

.footer .follow-us {
  font-size: 20px;
  font-weight: 600;
  line-height: 30px;
  color: #fff;
  margin-bottom: 15px;
}

/* ....................fotter-end............................... */

/* .......................................login..................................... */
input[type="text"],
input[type="email"],
input[type="password"] {
  width: 100%;
}

.main-agileinfo {
  margin: 0 auto;
  width: 100%;
  max-width: 530px;
}

.login-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: calc(100vh - 115px);
}

.login-wrapper .login-titles {
  text-align: center;
  margin-bottom: 35px;
}

.login-wrapper .login-titles h1 {
  font-size: 32px;
  font-weight: 600;
  font-family: poppins;
}

.login-wrapper .login-titles p {
  font-size: 16px;
  font-weight: 400;
  font-family: poppins;
  color: black;
  margin: 0;
  letter-spacing: 0.3px;
}

.login-wrapper .sign-text {
  font-size: 15px;
  color: rgb(0, 0, 0);
  text-align: center;
  letter-spacing: 0.3px;
  font-weight: 400;
  margin: 0;
  font-family: Poppins;
}

.login-wrapper .sign-text a {
  color: rgb(0, 0, 0);
  transition: 0.5s all;
  text-decoration: none;
  font-weight: 400;
}

.login-wrapper .sign-text a:hover {
  color: #000000;
  text-decoration: none;
}

.login-wrapper :-ms-input-placeholder {
  color: rgb(0, 0, 0);
}

.login-wrapper input[type="submit"] {
  font-size: 16px;
  font-weight: 400;
  color: rgb(255, 255, 255);
  background: #000000;
  outline: none;
  border: 1px solid #000000;
  padding: 11px 13px;
  -webkit-appearance: none;
  width: 100%;
  margin: 25px 0;
  letter-spacing: 4px;
  border-radius: 4px;
}

.login-wrapper input[type="submit"]:hover {
  transition: 0.5s all;
  background: #2b2b2b;
  border: 1px solid #000000;
  color: rgb(255, 255, 255);
}

.login-wrapper .login-forgotpw {
  font-size: 14px;
  color: rgb(0, 0, 0);
  text-align: center;
  letter-spacing: 0.3px;
  font-family: poppins;
  font-weight: 500;
  text-decoration: none;
}

.login-wrapper .login-forgotpw:hover {
  color: black;
  text-decoration: none;
}

.login-wrapper .checkbox-text {
  font-size: 15px;
  color: rgb(0, 0, 0);
  line-height: 24px;
  margin: 0;
  letter-spacing: 0.3px;
  font-weight: 400;
  font-family: poppins;
}

.login-wrapper .anim {
  display: block;
  position: relative;
  padding-left: 27px;
  margin: 7px 0 0 0;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  user-select: none;
}

.login-wrapper .anim input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.login-wrapper .checkmark {
  position: absolute;
  top: 3px;
  left: 0;
  height: 18px;
  width: 18px;
  background-color: #fff;
  border: 1px solid;
}

.login-wrapper .anim:hover input~.checkmark {
  background-color: #fff;
  border: 1px solid;
}

.login-wrapper .contact-feild {
  background: none !important;
  padding: 11px 13px !important;
  margin-bottom: 25px;
  border: 1px solid #989898;
  border-radius: 5px;
}

.login-wrapper .anim input:checked~.checkmark {
  background-color: #000000;
}

.login-wrapper .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.login-wrapper .anim input:checked~.checkmark:after {
  display: block;
}

.login-wrapper .anim .checkmark:after {
  left: 5px;
  top: 1px;
  width: 6px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  transform: rotate(45deg);
}

.login-wrapper input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-transition: background-color 5000s ease-in-out 0s;
  transition: background-color 5000s ease-in-out 0s;
}

/* ..............login-end------------------------- */

/* ...................about -page.............................. */
.about-banner .banner-img-wrapper {
  position: relative;
}

.about-banner .bannerBg {
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: -1;

}

.about-banner {
  padding-bottom: 100px;
  position: relative;
}

.about-banner .banner-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.about-banner .banner-text h2 {
  font-family: "Poppins";
  font-weight: 400;
  font-size: 42px;
  color: #ffffff;
  margin-bottom: 10px;
}

.about-banner .banner-text p {
  font-family: "Poppins";
  font-weight: 400;
  font-size: 16px;
  line-height: normal;
  color: #ffffff;
  max-width: 500px;
  margin: 0 auto;
}

.about-banner .banner-img {
  position: relative;
  padding-top: 20%;
  width: 100%;
  margin-bottom: 80px;
}

@media screen and (max-width:992px) {
  .about-banner .banner-img {
    padding-top: 35%;
  }
}

.about-banner .banner-img img {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  object-fit: cover;
}

.about-banner .banner-bottom-text {
  font-family: "Poppins";
  font-weight: 400;
  font-size: 16px;
  line-height: normal;
  color: #000000;
  text-align: left;
  margin: 0 auto;
  max-width: 950px;
}

/* ..........story start.................. */
.story-wrapper {
  background: #000;
  padding: 60px 0;
  position: relative;
}

.story-wrapper .storyBg {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 0;
}

.story-wrapper h2 {
  font-family: "Poppins";
  font-weight: 400;
  font-size: 32px;
  line-height: normal;
  color: #ffffff;
  margin-bottom: 12px;
}

.story-wrapper p {
  font-family: "Poppins";
  font-weight: 400;
  font-size: 17px;
  color: #fff;
  margin-bottom: 30px;
  line-height: normal;
}

.story-wrapper .story-right {
  width: 100%;
  height: 100%;
  object-fit: cover;
  padding: 60px;
}

/* ........story-end.............. */

/* ................blog-start............. */
.blog-wrapper {
  padding: 100px 0;
}

.blog-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.blog-wrapper .slick-next {
  background: rgba(0, 0, 0, 0);
  width: 25px;
  height: 25px;
  z-index: 1;
  right: -20px;
}

.blog-wrapper .slick-next::before {
  font-size: 30px;
  color: #000;
}

.blog-wrapper .slick-prev {
  background: rgba(0, 0, 0, 0);
  width: 25px;
  height: 25px;
  left: auto;
  right: 7px;
  z-index: 1;
}

.blog-wrapper .slick-prev::before {
  font-size: 30px;
  color: #000;
}

.blog-wrapper h2 {
  font-family: "Poppins";
  font-weight: 400;
  font-size: 28px;
  line-height: normal;
  color: #000000;
  margin-bottom: 12px;
}

.blog-wrapper p {
  font-family: "Poppins";
  font-weight: 400;
  font-size: 17px;
  line-height: 27px;
  color: #000000;
  margin-bottom: 7px;
}

.blog-wrapper ul {
  list-style: disc;
}

.blog-wrapper ul li {
  font-family: "Poppins";
  font-weight: 400;
  font-size: 17px;
  line-height: 26px;
  color: #000000;
}

.blog-wrapper .blog-text {
  padding-left: 60px;
}

/* .................blog-end............. */

/* ............code-block-start......... */
.code--block {
  padding: 0 0 100px 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.code-slider {
  position: absolute;
  right: 0;
  width: 50%;
}

.code-text {
  width: 50%;
  padding-right: 60px;
}

.code--block img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.code--block h2 {
  font-family: "Poppins";
  font-weight: 400;
  font-size: 28px;
  color: #000000;
  margin-bottom: 12px;
  line-height: normal;
}

.code--block p {
  font-family: "Poppins";
  font-size: 17px;
  line-height: normal;
  color: #000000;
}

.code--block .slick-initialized .slick-slide {
  padding: 0 0 0 14px;
}

.code--block .slick-initialized .slick-slide div:focus-visible {
  outline: 0;
}

.code--block img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 5px;
}

.code--block img:focus-visible {
  outline: 0;
}

.code--block .slick-track {
  padding: 0;
}

/* ..............code-block........end */

/* ..............work-block start............ */
.work-block {
  background: #f3f5f6;
  padding: 70px 0;
  position: relative;
}

.work-block .bottomBg {
  position: absolute;
  bottom: 0;
  z-index: 1;
  width: 100%;
}

.work-block h2 {
  font-family: "Poppins";
  font-weight: 400;
  font-size: 32px;
  line-height: normal;
  text-align: center;
  color: #000000;
  margin-bottom: 10px;
}

.work-block p {
  font-family: "Poppins";
  font-weight: 400;
  font-size: 17px;
  line-height: normal;
  max-width: 800px;
  margin: 0 auto 25px;
  text-align: center;
  color: #000000;
}

.learn-more {
  max-width: 165px;
  padding: 15px 25px;
  margin: 0 auto;
  width: 100%;
  text-align: center;
  background: #000;
  border-radius: 5px;
}

.learn-more a {
  font-family: "Poppins";
  font-weight: 400;
  font-size: 18px;
  color: #fff;
  text-decoration: none;
  position: relative;
  z-index: 1;
}

.learn-more a:hover {
  color: #fff;
}

/* ................work-block end....................... */

/* ...........................features-page...................... */
.features-banner .banner-img-wrapper {
  position: relative;
}

.features-banner .bannerBg {
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: -1;
}

.features-banner {
  padding-bottom: 50px;
}

.features-banner .banner-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.features-banner .banner-text h2 {
  font-family: "Poppins";
  font-weight: 400;
  font-size: 42px;
  color: #ffffff;
  margin-bottom: 10px;
  line-height: normal;
}

.features-banner .banner-text p {
  font-family: "Poppins";
  font-weight: 400;
  font-size: 18px;
  line-height: 27px;
  color: #ffffff;
  margin: 0;
}

.features-banner .banner-img {
  position: relative;
  padding-top: 20%;
  width: 100%;
}

@media screen and (max-width:992px) {
  .features-banner .banner-img {
    padding-top: 35%;
  }
}

.features-banner .banner-img img {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  object-fit: cover;
}

.features-banner .banner-bottom-text {
  font-family: "Poppins";
  font-weight: 400;
  font-size: 18px;
  line-height: 27px;
  color: #000000;
  text-align: center;
  margin: 0 auto;
  max-width: 860px;
}

/* .......................features-page end......................... */

/* ..........features-wrapper-start....... */
.features-wrapper .features-list {
  padding: 100px 0;
  position: relative;
}

.features-wrapper .features-block {
  flex-direction: row-reverse;
}

.features-wrapper .features-list .right-bg {
  position: absolute;
  bottom: 0;
  right: 0;
}

.features-wrapper .features-list .left-bg {
  position: absolute;
  bottom: 0;
  left: 0;
}

.features-wrapper .features-list .top-bottom-bg {
  position: absolute;
  bottom: 0;
  right: 0;
  height: 100%;
  width: 100%;
}

.features-wrapper .features-list .group-bg {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
}

.features-wrapper .features-list:nth-child(2) {
  background-color: #f3f5f6;
}

.features-wrapper .features-list:nth-child(4) {
  background-color: #f3f5f6;
}

.features-wrapper .features-list:nth-child(6) {
  background-color: #000000;
  text-align: center;
}

.features-wrapper .features-list:nth-child(6) h3 {
  font-family: Poppins;
  font-weight: 400;
  font-size: 50px;
  line-height: 50px;
  color: #ffffff;
  margin-bottom: 25px;
}

.features-wrapper .features-list:nth-child(6) p {
  font-family: Poppins;
  font-weight: 400;
  font-size: 17px;
  color: #ffffff;
}

.features-wrapper .features-list:nth-child(8) {
  background-color: #f3f5f6;
  text-align: center;
}

.features-wrapper .features-list h3 {
  font-family: Poppins;
  font-weight: 400;
  font-size: 28px;
  line-height: normal;
  color: #000000;
  margin-bottom: 12px;
}

.features-wrapper .features-list p {
  font-family: Poppins;
  font-weight: 400;
  font-size: 17px;
  color: #000000;
  margin-bottom: 30px;
  line-height: normal;
}

.features-wrapper .features-list .featue-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: drop-shadow(1px 1px 50px rgba(0, 0, 0, 0.1));
}

.features-wrapper .features-list .explore-btn {
  max-width: 150px;
  background: #000;
  padding: 12px 15px;
  border-radius: 5px;
  text-align: center;
}

.features-wrapper .features-list .explore-btn a {
  color: #fff;
  text-decoration: none;
  font-size: 16px;
}

.features-wrapper .features-list:first-child .featue-img {
  padding-left: 50px;
}

.features-wrapper .features-list:nth-child(2) .featue-img {
  padding-right: 50px;
}

.features-wrapper .features-list:nth-child(3) .featue-img {
  padding-left: 50px;
}

.features-wrapper .features-list:nth-child(4) .featue-img {
  padding-right: 50px;
}

.features-wrapper .features-list:nth-child(5) .featue-img {
  padding-left: 50px;
}

.features-wrapper .features-list:nth-child(7) .featue-img {
  padding-left: 50px;
}

/* .............features-wrapper-end......... */

/* .......................blog-start....................... */
.blog-banner .banner-img-wrapper {
  position: relative;
}

.blog-banner .bannerBg {
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: -1;
}

.blog-banner .banner-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.blog-banner .banner-text h2 {
  font-family: "Poppins";
  font-weight: 400;
  font-size: 42px;
  line-height: normal;
  color: #ffffff;
  margin-bottom: 10px;
}

.blog-banner .banner-text p {
  font-family: "Poppins";
  font-weight: 400;
  font-size: 17px;
  line-height: normal;
  color: #ffffff;
  margin: 0;
}

.blog-banner .banner-img {
  position: relative;
  padding-top: 20%;
  width: 100%;
}

@media screen and (max-width:767px) {
  .blog-banner .banner-img {
    padding-top: 65% !important;
  }
}

.blog-banner .banner-img img {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  object-fit: cover;
}

.cicd-block img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.cicd-block ul {
  list-style: disc;
}

.cicd-block ul li {
  font-family: "Poppins";
  font-weight: 400;
  font-size: 17px;
  line-height: normal;
  color: #000000;
}

.cicd-block {
  padding: 80px 0;
}

.cicd-pipeline {
  padding: 20px 0 80px;
}

.cicd-pipeline h2 {
  font-family: "Poppins";
  font-weight: 400;
  font-size: 28px;
  list-style: normal;
  color: #000000;
  margin-bottom: 12px;
}

.cicd-pipeline p {
  font-family: "Poppins";
  font-weight: 400;
  font-size: 17px;
  line-height: normal;
  color: #000000;
}

.cicd-pipeline .cicd-slider {
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.15));
  background: #fff;
  padding: 37px 0 58px 37px;
  border-radius: 10px;
}

.cicd-pipeline .cicd-slider h4 {
  font-family: "Poppins";
  font-weight: 400;
  font-size: 22px;
  line-height: normal;
  margin-bottom: 15px;
  color: #000000;
}

.cicd-pipeline .cicd-slider p {
  font-family: "Poppins";
  font-weight: 500;
  font-size: 16px;
  color: #000000;
  margin-top: 7px;
}

.cicd-pipeline .cicd-slider img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
}

.cicd-pipeline .cicd-slider .slick-initialized .slick-slide {
  padding: 0 0 0 14px;
}

.cicd-pipeline .cicd-slider .slick-initialized .slick-slide div:focus-visible {
  outline: 0;
}

.cicd-pipeline .cicd-slider .slick-track {
  padding: 0;
}

.article-wrapper {
  padding-bottom: 50px;
}

.article-wrapper h2 {
  font-family: "Poppins";
  font-weight: 400;
  font-size: 32px;
  color: #000000;
  text-align: center;
  margin-bottom: 40px;
}

.article-wrapper .article-img {
  position: relative;
  padding-top: 60%;
  width: 100%;
}

.article-wrapper .article-img img {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  object-fit: cover;
  border-radius: 10px;
}

.article-wrapper .card {
  margin-bottom: 40px;
  padding: 15px;
  border: none;
  box-shadow: 1px 1px 50px rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  text-decoration: none;
}

.article-wrapper .article-text {
  text-align: left;
  margin-top: 20px;
}

.article-wrapper .article-text h4 {
  font-family: "Poppins";
  font-weight: 600;
  font-size: 14px;
  color: #0950bb;
  margin-bottom: 20px;
}

.article-wrapper .article-text p {
  font-family: "Poppins";
  font-weight: 400;
  font-size: 18px;
  color: #000000;
}

.stay-up-block .mail-input {
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 5px;
  padding: 10px 10px 10px 23px;
  position: relative;
  z-index: 1;
}

.stay-up-block .mail-input img {
  width: 28px;
  object-fit: contain;
  height: 28px;
}

.stay-up-block .mail-input button {
  background: #000;
  color: #fff;
  padding: 6px 40px;
  border-radius: 5px;
}

.stay-up-block .mail-input input {
  border: none;
  background: rgba(255, 255, 255, 0);
  padding: 0;
}

.stay-up-block .mail-input input:focus-visible {
  outline: none;
}

.stay-up-block {
  background: #f3f5f6;
  padding: 80px 0 80px;
  position: relative;
}

.stay-up-block .group-bg {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
}

.stay-up-block h2 {
  font-family: "Poppins";
  font-weight: 400;
  font-size: 28px;
  line-height: normal;
  color: #000000;
  margin-bottom: 12px;
}

.stay-up-block p {
  font-family: "Poppins";
  font-weight: 400;
  font-size: 17px;
  line-height: normal;
  color: #000000;
}

/* .........................blog-end.................. */

/* ..........................blog-view start................ */
.blog-view-banner .date {
  display: flex;
  align-items: center;
}

.blog-pagination .pagination {
  justify-content: center;
}

.blog-pagination .pagination a {
  color: #000;
}

.blog-view-banner h2 {
  font-family: "Poppins";
  font-weight: 400;
  font-size: 42px;
  padding-right: 20px;
  line-height: 60px;
  color: #000000;
  margin-bottom: 20px;
}

.blog-view-banner .date img {
  width: 35px;
  height: 35px;
  object-fit: contain;
  margin-right: 13px;
}

.blog-view-banner .date p {
  margin: 0;
  font-family: "Poppins";
  font-weight: 400;
  font-size: 18px;
  line-height: 36px;
  color: #898989;
}

.blog-view-banner .right-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
}

.blog-view-banner {
  padding: 50px 0;
  border-bottom: 1px solid #ececec;
}

.blog-view-text h4 {
  font-family: "Poppins";
  font-weight: 600;
  font-size: 14px;
  color: #0950bb;
  margin-bottom: 30px;
}

.blog-view-text p {
  font-family: "Poppins";
  font-weight: 400;
  font-size: 18px;
  color: #000000;
  margin-bottom: 30px;
  text-align: justify;
}

.blog-view-text {
  padding: 40px 0 50px;
}

.article-slider h2 {
  font-family: "Poppins";
  font-weight: 400;
  font-size: 50px;
  color: #000000;
  text-align: center;
  margin-bottom: 40px;
}

.article-slider .slick-track {
  padding: 0;
}

.article-slider .card {
  margin-bottom: 40px;
  padding: 15px;
  border: none;
  border-radius: 10px;
  text-decoration: none;
}

.article-slider .blog-text {
  text-align: left;
  margin-top: 20px;
}

.article-slider .card h4 {
  font-family: "Poppins";
  font-weight: 600;
  font-size: 14px;
  color: #0950bb;
  margin-bottom: 20px;
}

.article-slider .card p {
  font-family: "Poppins";
  font-weight: 400;
  font-size: 18px;
  color: #000000;
}

.article-slider img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
}

.article-slider .article-list {
  padding: 0 15px;
}

.article-slider {
  padding: 50px 0 80px;
}

/* ............................blog-view-end................. */

/*.....................career-start...................  */
.career-banner .banner-img-wrapper {
  position: relative;
}

.career-banner .bannerBg {
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: -1;
}

.career-banner .banner-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.career-banner .banner-text h2 {
  font-family: "Poppins";
  font-weight: 400;
  font-size: 42px;
  line-height: normal;
  color: #ffffff;
  margin-bottom: 12px;
}

.career-banner .banner-text p {
  font-family: "Poppins";
  font-weight: 400;
  font-size: 17px;
  line-height: normal;
  color: #ffffff;
  margin: 0;
}

.career-banner .banner-img {
  position: relative;
  padding-top: 20%;
  width: 100%;
}

@media screen and (max-width:767px) {
  .career-banner .banner-img {
    padding-top: 65% !important;
  }
}

.career-banner .banner-img img {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  object-fit: cover;
}

.jobs-details h3 {
  font-family: "Poppins";
  font-weight: 500;
  font-size: 26px;
  line-height: 30px;
  color: #000000;
  margin-bottom: 20px;
}

.jobs-details .jobs-list {
  max-width: 700px;
  margin: 0 auto;
  width: 100%;
}

.jobs-details .jobs-list .jobs-item {
  padding: 25px 38px;
  border-bottom: 1px solid #d9d9d9;
  position: relative;
}

.jobs-details {
  padding: 70px 0;
}

.jobs-list p {
  margin: 0;
  font-size: 17px;
  font-weight: 400;
  line-height: normal;
}

.jobs-details .jobs-list .jobs-item h4 {
  font-family: "Poppins";
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  color: #000000;
}

.jobs-details .jobs-list .jobs-item p {
  font-family: "Poppins";
  font-weight: 400;
  font-size: 16px;
  line-height: 28px;
  color: #000000;
}

.jobs-details .jobs-list .jobs-item .explore-btn {
  max-width: 150px;
  background: rgb(255, 255, 255);
  border: 2px solid #b7b7b7;
  padding: 12px 15px;
  border-radius: 5px;
  text-align: center;
  margin: 0 0 0 auto;
}

.jobs-details .jobs-list .jobs-item .explore-btn a {
  color: #939393;
  font-size: 15px;
  text-decoration: none;
  font-weight: 500;
}

.career-pagination {
  margin: 50px 0;
}

.career-pagination .pagination {
  justify-content: center;
}

.career-pagination .pagination .page-link {
  color: #000;
}

.jobs-details .jobs-list .jobs-item:hover {
  border-color: transparent;
  background: #f6f6f6;
}

.jobs-details .jobs-list .jobs-item:hover::before {
  opacity: 1;
}

.jobs-details .jobs-list .jobs-item::before {
  content: '';
  height: 100%;
  width: 4px;
  background: #000000;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  transition: all .3s ease-in-out;
}

.jobs-details .jobs-list .jobs-item.active .explore-btn {
  background: #000;
  border: 1px solid #000;
}

.jobs-details .jobs-list .jobs-item.active .explore-btn a {
  color: #fff;
}

/* ....................career-end................... */

/* ..........................casestudy start............... */
.case-study-list img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: drop-shadow(1px 1px 50px rgba(0, 0, 0, 0.15));
  border-radius: 10px;
}

.case-study-block {
  flex-direction: row-reverse;
}

.case-study-text h4 {
  font-family: "Poppins";
  font-weight: 400;
  font-size: 28px;
  line-height: normal;
  color: #000000;
  max-width: 480px;
  margin-bottom: 20px;
}

@media screen and (max-width:992px) {
  .case-study-text h4 {
    max-width: 100%;
  }
}

.case-study-text .read-more {
  max-width: 150px;
  background: #000;
  padding: 12px 15px;
  border-radius: 5px;
  text-align: center;
}

.read-more {
  font-weight: 600;
  cursor: pointer;
}

.case-study-text {
  padding-right: 60px;
}

.case-study-block .case-study-text {
  padding-left: 60px;
  padding-right: 0;
}

.case-study-text .read-more a {
  color: #fff;
  text-decoration: none;
  font-size: 14px;
  font-weight: 400;
}

.casestudy-banner .banner-img-wrapper {
  position: relative;
}

.casestudy-banner .bannerBg {
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: -1;
}

.casestudy-banner {
  padding-bottom: 50px;
}

.casestudy-banner .banner-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

@media screen and (max-width:767px) {

  .casestudy-banner .banner-text,
  .pricing-banner .banner-text,
  .blog-banner .banner-text,
  .career-banner .banner-text,
  .features-banner .banner-text,
  .about-banner .banner-text {
    width: 100%;
    padding: 15px;
  }
}

.casestudy-banner .banner-text h2 {
  font-family: "Poppins";
  font-weight: 400;
  font-size: 42px;
  line-height: normal;
  color: #ffffff;
  margin-bottom: 12px;
}

.casestudy-banner .banner-text p {
  font-family: "Poppins";
  font-weight: 400;
  font-size: 17px;
  line-height: normal;
  color: #ffffff;
  margin: 0;
}

.casestudy-banner .banner-img {
  position: relative;
  padding-top: 20%;
  width: 100%;
}

@media screen and (max-width:767px) {
  .casestudy-banner .banner-img {
    padding-top: 65% !important;
  }
}

.casestudy-banner .banner-img img {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  object-fit: cover;
}

.case-study-wrapper .case-study-list {
  padding: 50px 0;
}

.case-study-wrapper {
  padding-bottom: 50px;
}

/* .............................casestudy-end............... */

/* ..............pricing-start................. */
.pricing-banner .banner-img-wrapper {
  position: relative;
}

.pricing-banner .bannerBg {
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: -1;
}

.pricing-banner {
  padding-bottom: 40px;
}

.pricing-banner .banner-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.pricing-banner .banner-text h2 {
  font-family: "Poppins";
  font-weight: 400;
  font-size: 32px;
  line-height: normal;
  color: #ffffff;
  margin-bottom: 12px;
}

.pricing-banner .banner-text p {
  font-family: "Poppins";
  font-weight: 400;
  font-size: 17px;
  line-height: normal;
  color: #ffffff;
  margin: 0;
}

.pricing-banner .banner-img {
  position: relative;
  padding-top: 20%;
  width: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.pricing-banner .banner-img img {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  object-fit: cover;
}

.pricing-wrapper .pricing-card {
  background: #f3f5f6;
  padding: 50px 30px 76px 30px;
  text-align: center;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
}

@media screen and (max-width:992px) {
  .pricing-wrapper .pricing-card {
    padding: 50px 15px;
  }
}

.pricing-wrapper .pricing-card h4 {
  font-family: "Poppins";
  font-weight: 500;
  font-size: 24px;
  margin-bottom: 25px;
  text-align: center;
  color: #000000;
}

.pricing-wrapper .pricing-card h1 {
  font-family: "Poppins";
  font-weight: 600;
  font-size: 52px;
  line-height: 60px;
  text-align: center;
  color: #000000;
}

.pricing-wrapper .pricing-card h1 span {
  font-size: 23px;
}

.pricing-wrapper .pricing-card p {
  font-family: "Poppins";
  font-weight: 400;
  font-size: 17px;
  line-height: normal;
  text-align: center;
  color: #000000;
  margin: 0;
}

.pricing-wrapper .pricing-card .read-more {
  max-width: 175px;
  font-size: 14px;
  font-weight: 400;
  background: black;
  padding: 11px 35px;
  text-align: center;
  border-radius: 5px;
  margin: 40px auto 0;
}

.pricing-wrapper .pricing-card .read-more a {
  color: #fff;
  text-decoration: none;
}

.pricing-wrapper .pricing-card:hover {
  background: #000;
}

.pricing-wrapper .pricing-card:hover h4 {
  color: #fff;
}

.pricing-wrapper .pricing-card:hover h1 {
  color: #fff;
}

.pricing-wrapper .pricing-card:hover p {
  color: #fff;
}

.pricing-wrapper .pricing-card:hover .read-more {
  background: #fff;
}

.pricing-wrapper .pricing-card:hover .read-more a {
  color: #000;
  font-weight: 500;
}

.pricing-wrapper {
  padding: 50px 0 90px;
}

/* ...........pricing-end.................. */

/* ...............media. start.................................... */
@media screen and (max-width: 767px) {

  /* .enhance {
    font-family: Poppins;
    font-weight: 800;
    line-height: 60px;
    color: black;
    font-size: 55px;
    display: block;
  }

  .your {
    font-family: Poppins;
    font-weight: 800;
    line-height: 50px;
    color: black;
    font-size: 55px;
    display: block;
  }

  .productivity {
    font-family: Poppins;
    font-weight: 800;
    line-height: 60px;
    color: black;
    font-size: 55px;
    display: block;
  } */
  .about-banner .banner-text h2 {
    font-size: 35px;
    margin-bottom: 10px;
  }

  .about-banner .banner-text p {
    font-size: 16px;
    line-height: 23px;
  }

  .about-banner .banner-img {
    padding-top: 65%;
    margin-bottom: 55px;
  }

  .our-clients {
    padding: 50px 0;
  }

  .about-banner .banner-bottom-text {
    font-size: 16px;
    line-height: 25px;
  }

  .about-banner {
    padding-bottom: 45px;
  }

  .story-wrapper {
    padding: 50px 0;
    text-align: center;
  }

  .story-wrapper h2 {
    font-size: 35px;
  }

  .story-wrapper p {
    font-size: 16px;
    line-height: 27px;
  }

  .story-wrapper .story-right {
    padding: 30px;
  }

  .about-banner .bannerBg {
    display: none;
  }

  .story-wrapper .storyBg {
    display: none;
  }

  .blog-wrapper {
    padding: 80px 0 50px;
  }

  .blog-wrapper .blog-text {
    padding: 0 15px;
    margin-top: 40px;
  }

  .blog-wrapper p {
    font-size: 16px;
    line-height: 27px;
  }

  .code--block {
    padding: 30px 0 50px;
    text-align: center;
  }

  .code--block p {
    font-size: 17px;
    margin: 0;
  }

  .code--block h2 {
    font-size: 35px;
  }

  .work-block h2 {
    font-size: 35px;
    line-height: 35px;
  }

  .work-block p {
    font-size: 17px;
  }

  .features-banner .banner-text h2 {
    font-size: 35px;
    margin-bottom: 8px;
  }

  .features-banner .banner-text p {
    font-size: 16px;
    line-height: 24px;
  }

  .features-wrapper .features-list p {
    margin-bottom: 30px;
  }

  .features-wrapper .features-block {
    flex-direction: row;
  }

  .features-wrapper .features-list h3 {
    font-size: 35px;
    margin-bottom: 10px;
  }

  .features-wrapper .features-list:nth-child(6) h3 {
    font-size: 35px;
    margin-bottom: 10px;
  }

  .features-wrapper .features-list {
    padding: 40px 0;
  }

  .blog-view-banner h2 {
    font-size: 33px;
    line-height: 50px;
    padding-right: 0;
  }

  .blog-view-text p {
    font-size: 16px;
  }

  .article-slider h2 {
    font-size: 33px;
    margin-bottom: 20px;
  }

  .blog-view-text {
    padding: 30px 0 0;
  }

  .blog-banner .banner-text h2 {
    font-size: 33px;
  }

  .blog-banner .banner-text p {
    font-size: 16px;
    line-height: 24px;
  }

  .cicd-block ul li {
    font-size: 16px;
  }

  .cicd-block {
    padding: 50px 0;
  }

  .cicd-pipeline h2 {
    font-size: 33px;
  }

  .cicd-pipeline p {
    font-size: 16px;
  }

  .article-wrapper h2 {
    font-size: 33px;
    margin-bottom: 30px;
  }

  .stay-up-block {
    padding: 50px 0;
  }

  .article-wrapper .article-text {
    text-align: center;
  }

  .stay-up-block h2 {
    font-size: 30px;
    margin-bottom: 13px;
  }

  .career-banner .banner-text h2 {
    font-size: 33px;
    margin-bottom: 10px;
  }

  .career-banner .banner-text p {
    font-size: 16px;
    line-height: 23px;
  }

  .jobs-details .jobs-list .jobs-item {
    padding: 25px;
  }

  .jobs-details .jobs-list .jobs-item p {
    line-height: 24px;
    font-size: 15px;
  }

  .stay-up-block p {
    font-size: 16px;
  }

  .casestudy-banner .banner-text h2 {
    font-size: 33px;
    margin-bottom: 10px;
  }

  .casestudy-banner .banner-text p {
    font-size: 16px;
    line-height: 23px;
  }

  .casestudy-banner {
    padding-bottom: 30px;
  }

  .case-study-wrapper .case-study-list {
    padding: 30px 0;
  }

  .case-study-text h4 {
    font-size: 30px;
    line-height: 45px;
  }

  .pricing-banner .banner-text h2 {
    font-size: 33px;
    margin-bottom: 10px;
  }

  .pricing-banner .banner-text p {
    font-size: 16px;
    line-height: 24px;
  }

  .pricing-banner .banner-img {
    padding-top: 80% !important;
  }

  .pricing-wrapper .pricing-card {
    padding: 35px 30px 50px;
  }

  .pricing-wrapper {
    padding: 20px 0 30px;
  }

  .pricing-wrapper .pricing-card h4 {
    margin-bottom: 40px;
  }

  .features-banner .banner-img {
    padding-top: 65%;
  }

  .banner-button-inner {
    gap: 10px;
  }

  .building-btn {
    padding: 10px 10px;
    margin: 0;
    min-width: 97px;
  }

  .ship-section-stats {
    padding: 25px 0;
  }

  .footer {
    padding: 25px 0;
    text-align: center;
  }

  .bugfree {
    padding-bottom: 40px;
  }

  .Start-btn {
    width: 100%;
    text-align: center;
    margin-bottom: 15px;
    margin-right: 0;
  }

  .Request-demo {
    width: 100%;
    text-align: center;
  }

  .Workflow-wrapper {
    width: 100% !important;
    margin-bottom: 40px;
    padding-right: 0 !important;
    text-align: center;
  }

  .footer .Workflow-para {
    margin-bottom: 25px;
  }

  .footer .bugfree-text {
    margin-bottom: 20px;
  }


}

@media screen and (max-width: 992px) {
  .header {
    padding: 10px 0;
  }

  .blog-wrapper .slick-next {
    right: 5px;
  }

  .blog-wrapper .slick-prev {
    right: auto;
  }

  .ship-section-wrapper-item {
    padding: 8px 10px;
    text-align: center;
    width: 50%;
  }

  .ship-section-wrapper-item:nth-child(2) {
    border-bottom: 1px solid #eaeaea;
    border-right: none;
  }

  .ship-section-wrapper-item:first-child {
    border-bottom: 1px solid #eaeaea;
  }

  .ship-section-wrapper-item .highlight {
    margin: 0;
    font-size: 37px;
  }

  .features-wrapper .features-list .featue-img {
    padding-top: 40px;
  }

  .features-wrapper .features-list .left-bg {
    display: none;
  }

  .features-wrapper .features-list .right-bg {
    display: none;
  }

  .features-wrapper .features-list .top-bottom-bg {
    display: none;
  }

  .features-wrapper .features-list .group-bg {
    display: none;
  }

  .stay-up-block .group-bg {
    display: none;
  }

  .features-banner {
    padding-bottom: 20px;
  }

  .features-wrapper {
    text-align: center;
  }

  .features-wrapper .features-list .explore-btn {
    margin: 0 auto;
  }

  .features-wrapper .features-list:first-child .featue-img {
    padding-left: 0;
  }

  .features-wrapper .features-list:nth-child(2) .featue-img {
    padding-right: 0;
  }

  .features-wrapper .features-list:nth-child(3) .featue-img {
    padding-left: 0;
  }

  .features-wrapper .features-list:nth-child(4) .featue-img {
    padding-right: 0;
  }

  .features-wrapper .features-list:nth-child(5) .featue-img {
    padding-left: 0;
  }

  .features-wrapper .features-list:nth-child(7) .featue-img {
    padding-left: 0;
  }

  .blog-view-banner .right-img {
    margin-top: 40px;
  }

  .blog-view-text {
    text-align: center;
  }

  .blog-view-banner h2 {
    text-align: center;
  }

  .blog-view-banner .date {
    justify-content: center;
  }

  .blog-banner .banner-img {
    padding-top: 35%;
  }

  .cicd-block img {
    margin-bottom: 50px;
  }

  .cicd-block {
    text-align: center;
  }

  .cicd-pipeline {
    text-align: center;
  }

  .stay-up-block {
    text-align: center;
  }

  .code-text {
    width: 100%;
    padding: 0;
    text-align: center;
  }

  .code-slider {
    width: 100%;
    position: unset;
    margin-bottom: 40px;
  }

  .code-slider .slick-track {
    padding: 0;
  }

  .code-slider .slick-track {
    display: flex;
    height: inherit;
  }

  .blog-wrapper h2 {
    text-align: center;
    line-height: 45px;
  }

  .story-wrapper {
    text-align: center;
  }

  .blog-wrapper img {
    margin-bottom: 50px;
  }

  .career-banner .banner-img {
    padding-top: 35%;
  }

  .case-study-block .case-study-text {
    padding-bottom: 50px;
    padding-left: 0;
    padding-right: 0;
    text-align: center;
  }

  .case-study-text {
    padding-bottom: 50px;
    text-align: center;
    padding-left: 0;
    padding-right: 0;
  }

  .case-study-text .read-more {
    margin: 0 auto;
  }

  .case-study-block {
    flex-direction: row;
  }

  .casestudy-banner .banner-img {
    padding-top: 35%;
  }

  .pricing-banner .banner-img {
    padding-top: 35%;
  }

  .pricing-wrapper .col-lg-4 {
    margin-bottom: 40px;
  }
}

/* ...............media. end.................................... */
@media screen and (min-width: 768px) {
  .testimonials .slick-track {
    display: flex;
  }
}

@media (min-width: 1025px) {


  .menu-list li {
    display: inline-block;
    padding: 0 13px;
  }

  .menu-list li a {
    color: #000;
    text-decoration: none;
    font-size: 15px;
    font-family: "Poppins";
    font-weight: 600;
    cursor: pointer;
    text-transform: uppercase;
  }

  .card-inner {
    width: 31%;
    padding: 50px 30px;
    min-height: 265px;
  }

  .card-inner a {
    bottom: -17px;
    width: 33%;
  }
}

@keyframes colorEnhance {
  0% {
    color: #000000;
    animation-timing-function: ease-in-out;
  }

  20% {
    color: #000000;
    animation-timing-function: ease-in-out;
  }

  25% {
    color: #0391c9;
    animation-timing-function: ease-in-out;
  }

  40% {
    color: #0391c9;
    animation-timing-function: ease-in-out;
  }

  45% {
    color: #000000;
    animation-timing-function: ease-in-out;
  }

  100% {
    color: #000000;
    animation-timing-function: ease-in-out;
  }
}

.enhanceText {
  animation: colorEnhance 13s linear infinite;
}

@keyframes colorYour {
  0% {
    color: #000000;
    animation-timing-function: ease-in-out;
  }

  40% {
    color: #000000;
    animation-timing-function: ease-in-out;
  }

  45% {
    color: #cc0055;
    animation-timing-function: ease-in-out;
  }

  60% {
    color: #cc0055;
    animation-timing-function: ease-in-out;
  }

  65% {
    color: #000000;
    animation-timing-function: ease-in-out;
  }

  100% {
    color: #000000;
    animation-timing-function: ease-in-out;
  }
}

.yourText {
  animation: colorYour 13s linear infinite;
}

@keyframes colorProduct {
  0% {
    color: #000000;
    animation-timing-function: ease-in-out;
  }

  40% {
    color: #000000;
    animation-timing-function: ease-in-out;
  }

  41% {
    color: #000000;
    animation-timing-function: ease-in-out;
  }

  60% {
    color: #000000;
    animation-timing-function: ease-in-out;
  }

  65% {
    color: #f1982e;
    animation-timing-function: ease-in-out;
  }

  80% {
    color: #f1982e;
    animation-timing-function: ease-in-out;
  }

  85% {
    color: #000000;
    animation-timing-function: ease-in-out;
  }

  100% {
    color: #000000;
    animation-timing-function: ease-in-out;
  }
}

.productText {
  animation: colorProduct 13s linear infinite;
}

.terms_conditions-wrapper {
  padding: 60px 0;
}

@media screen and (max-width:767px) {
  .terms_conditions-wrapper {
    padding: 50px 0;
  }
}

.terms_conditions-wrapper .heading {
  font-size: 32px;
  font-weight: 500;
  margin-bottom: 35px;
  line-height: normal;
}

@media screen and (max-width:767px) {
  .terms_conditions-wrapper .heading {
    font-size: 28px;
    text-align: center;
  }
}

.address-block {
  display: flex;
  justify-content: center;
  gap: 40px;
}

.contact-img {
  width: 100%;
  height: 300px;
  margin-bottom: 20px;
}

.contact-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@media screen and (max-width:767px) {
  .contact-details {
    margin-bottom: 25px;
    text-align: center;
  }
}

.contact-details h6 {
  font-size: 25px;
  font-weight: 500;
  color: #000;
  margin-bottom: 15px;
}

.contact-details p {
  margin-bottom: 5px;
  font-size: 16px;
  font-weight: 400;
  color: #000;
}

.faqs-block .accordion-button:not(.collapsed) {
  background: #000;
  color: #fff;
  box-shadow: none;
}

.faqs-block .accordion-button:not(.collapsed)::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) !important;
}

.faqs-block .accordion-button:focus {
  box-shadow: none;
}

.faqs-block .accordion-body {
  font-size: 16px;
  font-weight: 400;
  color: #000;
}

.faqs-block .accordion-button {
  font-size: 16px;
  font-weight: 400;
}

.navbar-expand-lg .container-fluid.navbar-nav {
  flex-direction: row;
}

.about-banner-container .banner-text h2 {
  font-weight: 600;
  margin-bottom: 15px;
}

.about-banner-container .banner-text h6 {
  font-size: 40px;
  font-weight: 600;
  color: #4874EB;
  margin: 0;
}

@media screen and (max-width:767px) {
  .about-banner-container .banner-text h6 {
    font-size: 28px;
  }
}

.about-banner-container .banner-text h6 span {
  color: #EE9D3A;
}

.about-banner-container {
  padding: 80px 0;
}

.about-para {
  margin: 20px 0;
}

.about-para p {
  font-size: 16px;
  font-weight: 400;
  color: #000;
  margin: 0;
}

.join-us {
  background: #000;
  border-radius: 5px;
  position: relative;
  padding: 10px 43px 10px 28px;
  display: inline-block;
}

.join-us a {
  text-decoration: none;
  color: #fff;
  font-size: 14px;
  font-weight: 400;
}

.join-us a:after {
  position: absolute;
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat;
  background-size: 15px;
  width: 15px;
  height: 15px;
  top: 15px;
  right: 18px;
}

.about-banner-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@media screen and (max-width:992px) {
  .about-banner-container {
    text-align: center;
  }
}

@media screen and (max-width:992px) {
  .join-us {
    margin-bottom: 25px;
  }
}`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,+DAA+D;EAC/D,6BAA6B;EAC7B,oCAAoC;EACpC,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,+DAA+D;EAC/D,6BAA6B;EAC7B,oCAAoC;EACpC,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,yDAAyD;EACzD,6BAA6B;EAC7B,oCAAoC;EACpC,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,4CAA4C;AAC5C;EACE,eAAe;EACf,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE;IACE,eAAe;IACf,SAAS;IACT,QAAQ;IACR,OAAO;IACP,SAAS;IACT,mBAAmB;IACnB,aAAa;IACb,+BAA+B;IAE/B,2BAA2B;EAC7B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;AACF;;AAEA;;;EAGE;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE;EACF;;EAEA;IACE,8CAA8C;EAChD;;EAEA;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,SAAS;IACT,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,kBAAkB;EACpB;;EAEA;;IAEE,WAAW;IACX,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,OAAO;IACP,gCAAgC;EAClC;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,SAAS;EACX;;AAEF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,+BAA+B;IAE/B,mCAAmC;EACrC;AACF;;AAEA,mDAAmD;AACnD;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE;IACE,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,8BAA8B;EAC9B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,oBAAoB;EACpB,qBAAqB;EACrB,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,wDAAwD;;AAExD,4DAA4D;AAC5D;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mEAAmE;;AAEnE,8EAA8E;AAC9E;EACE,4CAA4C;EAC5C,+CAA+C;EAC/C,4CAA4C;EAC5C,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,4EAA4E;;AAE5E,4EAA4E;;AAE5E;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,+CAA+C;EAC/C,eAAe;AACjB;;AAEA,0EAA0E;;AAE1E,kGAAkG;;AAElG;EACE,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,oEAA8D;EAC9D,4BAA4B;EAC5B,uBAAuB;EACvB,eAAe;EACf,OAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,oEAA+D;EAC/D,4BAA4B;EAC5B,uBAAuB;EACvB,eAAe;EACf,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,+DAA+D;;AAE/D,kEAAkE;AAClE;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA,kEAAkE;;AAElE,sFAAsF;AACtF;;;EAGE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EAGnB,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,wBAAwB;EACxB,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EAKE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,SAAS;EACT,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,yBAAyB;EAGzB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EAGzB,wBAAwB;AAC1B;;AAEA;;;;EAIE,yDAAiD;EAAjD,iDAAiD;AACnD;;AAEA,qDAAqD;;AAErD,iEAAiE;AACjE;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;;AAEb;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,4CAA4C;AAC5C;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,aAAa;AACf;;AAEA,oCAAoC;;AAEpC,4CAA4C;AAC5C;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,UAAU;EACV,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,2CAA2C;;AAE3C,0CAA0C;AAC1C;EACE,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA,wCAAwC;;AAExC,+CAA+C;AAC/C;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA,0DAA0D;;AAE1D,mEAAmE;AACnE;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA,sEAAsE;;AAEtE,4CAA4C;AAC5C;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,oDAAoD;AACtD;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,+CAA+C;;AAE/C,6DAA6D;AAC7D;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oDAAoD;EACpD,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,MAAM;EACN,OAAO;EACP,SAAS;EACT,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,4CAA4C;EAC5C,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kCAAkC;EAClC,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA,wDAAwD;;AAExD,8DAA8D;AAC9D;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,+DAA+D;;AAE/D,yDAAyD;AACzD;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA,sDAAsD;;AAEtD,6DAA6D;AAC7D;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,qDAAqD;EACrD,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;;EAEE;;;;;;IAME,WAAW;IACX,aAAa;EACf;AACF;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,8DAA8D;;AAE9D,iDAAiD;AACjD;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,yDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,6CAA6C;;AAE7C,oEAAoE;AACpE;;EAEE;;;;;;;;;;;;;;;;;;;;;;;;;KAyBG;EACH;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;;AAGF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,gCAAgC;IAChC,kBAAkB;EACpB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,kEAAkE;AAClE;EACE;IACE,aAAa;EACf;AACF;;AAEA;;;EAGE;IACE,qBAAqB;IACrB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,UAAU;IACV,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,UAAU;EACZ;AACF;;AAEA;EACE;IACE,cAAc;IACd,sCAAsC;EACxC;;EAEA;IACE,cAAc;IACd,sCAAsC;EACxC;;EAEA;IACE,cAAc;IACd,sCAAsC;EACxC;;EAEA;IACE,cAAc;IACd,sCAAsC;EACxC;;EAEA;IACE,cAAc;IACd,sCAAsC;EACxC;;EAEA;IACE,cAAc;IACd,sCAAsC;EACxC;AACF;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE;IACE,cAAc;IACd,sCAAsC;EACxC;;EAEA;IACE,cAAc;IACd,sCAAsC;EACxC;;EAEA;IACE,cAAc;IACd,sCAAsC;EACxC;;EAEA;IACE,cAAc;IACd,sCAAsC;EACxC;;EAEA;IACE,cAAc;IACd,sCAAsC;EACxC;;EAEA;IACE,cAAc;IACd,sCAAsC;EACxC;AACF;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE;IACE,cAAc;IACd,sCAAsC;EACxC;;EAEA;IACE,cAAc;IACd,sCAAsC;EACxC;;EAEA;IACE,cAAc;IACd,sCAAsC;EACxC;;EAEA;IACE,cAAc;IACd,sCAAsC;EACxC;;EAEA;IACE,cAAc;IACd,sCAAsC;EACxC;;EAEA;IACE,cAAc;IACd,sCAAsC;EACxC;;EAEA;IACE,cAAc;IACd,sCAAsC;EACxC;;EAEA;IACE,cAAc;IACd,sCAAsC;EACxC;AACF;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE;IACE,mBAAmB;IACnB,kBAAkB;EACpB;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,oEAAgS;AAClS;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,6DAAyD;EACzD,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF","sourcesContent":[":root {\n  --bs-font-sans-serif: Poppins;\n}\n\nbody {\n  font-family: var(--bs-font-sans-serif);\n}\n\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n.gradient-heading-lg-blue {\n  background: #4ecdff;\n  background: linear-gradient(to right, #4ecdff 31%, #0075e2 55%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  font-family: \"Poppins\";\n  font-size: 32px;\n  font-weight: 600;\n  text-align: center;\n  margin: 0 0 20px 0;\n}\n\n.gradient-heading-lg-pink {\n  background: #ff2a83;\n  background: linear-gradient(to right, #ff2a83 31%, #9c0041 55%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  font-family: \"Poppins\", sans-serif;\n  font-size: 32px;\n  font-weight: 800;\n  text-align: center;\n  margin: 0 0 20px 0;\n}\n\n.gradient-heading-lg-dark {\n  background: #333;\n  background: linear-gradient(to right, #333 45%, #000 50%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  font-family: \"Poppins\", sans-serif;\n  font-size: 32px;\n  font-weight: 600;\n  text-align: center;\n  margin: 0 0 20px 0;\n}\n\n/* ..............header start............. */\nheader {\n  padding: 15px 0;\n  position: sticky;\n  top: 0;\n  z-index: 999;\n  background: #fff;\n  transition: all .3s ease-in-out;\n}\n\nheader .navbar-brand img {\n  width: 150px;\n  margin: 0 auto;\n}\n\n.header .nav-item a {\n  color: #000;\n  font-size: 16px;\n  font-weight: 500;\n  text-decoration: none;\n}\n\n.header .nav-item {\n  padding: 0 10px;\n  white-space: nowrap;\n}\n\n.header .nav-item.active a {\n  border-bottom: 3px solid #000;\n}\n\nheader .navbar-toggler {\n  border: none;\n  padding: 1px 0;\n  height: 30px;\n  width: 35px;\n  transition: all 0.3s ease-in-out;\n}\n\n@media screen and (max-width:992px) {\n  .primary-menu-container {\n    position: fixed;\n    top: 85px;\n    right: 0;\n    left: 0;\n    bottom: 0;\n    background: #0a0b12;\n    z-index: 9999;\n    transition: all .2s ease-in-out;\n    -webkit-transform: translateX(100%);\n    transform: translateX(100%);\n  }\n\n  .primary-menu-container .navbar-nav {\n    padding: 30px 0;\n  }\n\n  .primary-menu-container .navbar-nav li a {\n    display: block;\n    padding: 10px 15px;\n  }\n}\n\n@media screen and (max-width:992px) {\n\n\n  .header .nav-item a {\n    color: rgb(255, 255, 255);\n  }\n\n  header .navbar-toggler[aria-expanded=true] .navbar-toggler-icon {\n    border-color: transparent;\n  }\n\n  .navbar-toggler[aria-expanded=true] .navbar-toggler-icon:before {\n    transform: rotate(45deg)\n  }\n\n  .navbar-toggler[aria-expanded=true] .navbar-toggler-icon:after {\n    transform: rotate(-45deg) translate(7px, -8px);\n  }\n\n  .header .navbar-toggler-icon {\n    background-image: none;\n    border-top: 3px solid #333;\n    margin: 0;\n    width: 21px;\n    height: 21px;\n    transition: all 0.3s ease-in-out;\n    position: relative;\n  }\n\n  header .navbar-toggler .navbar-toggler-icon:before,\n  header .navbar-toggler .navbar-toggler-icon:after {\n    content: '';\n    height: 3px;\n    width: 100%;\n    position: absolute;\n    background: #333;\n    left: 0;\n    transition: all 0.3s ease-in-out;\n  }\n\n  header .navbar-toggler .navbar-toggler-icon:before {\n    top: 5px;\n  }\n\n  header .navbar-toggler .navbar-toggler-icon:after {\n    bottom: 0;\n  }\n\n}\n\n@media screen and (max-width:992px) {\n  .primary-menu-container {\n    top: 70px;\n  }\n\n  .primary-menu-container.show {\n    transition: all .2s ease-in-out;\n    -webkit-transform: translateX(0) !important;\n    transform: translateX(0) !important;\n  }\n}\n\n/* ..............banner-start.................... */\n.banner-title {\n  margin-bottom: 45px;\n}\n\n.banner-inner {\n  padding: 50px 0;\n  /* height: calc(100vh - 125px); */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.banner-title-text {\n  text-align: center;\n  font-weight: 800;\n  color: black;\n  font-size: 135px;\n  line-height: 150px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  /* font-family: Poppins; */\n}\n\n@media (max-width: 1229px) {\n  .banner-title-text {\n    font-size: 85px;\n    line-height: 100px;\n  }\n}\n\n@media (max-width: 767px) {\n  .banner-title-text {\n    line-height: 13.5vw;\n    font-size: 13.5vw;\n  }\n\n  .footer-list-wrapper {\n    width: 100%;\n  }\n}\n\n.banner-button-inner {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n  margin-bottom: 45px;\n}\n\n.building-btn {\n  background-color: rgb(0, 0, 0);\n  padding: 15px 35px;\n  color: rgb(255, 255, 255);\n  border-radius: 6px;\n  text-decoration: none;\n  cursor: pointer;\n  border: 1px solid rgb(0, 0, 0);\n  margin: 0 10px;\n  min-width: 180px;\n}\n\n.building-btn:last-child {\n  background-color: rgb(255, 255, 255);\n  color: rgb(0, 0, 0);\n}\n\n.building-btn:hover {\n  background-color: rgb(255, 255, 255);\n  color: rgb(0, 0, 0);\n}\n\n.banner-description-text {\n  font-size: 18px;\n  font-weight: 400;\n  color: #000;\n  font-family: Poppins;\n  letter-spacing: 0.2px;\n  margin: 0 auto;\n  padding: 0;\n  text-align: center;\n  max-width: 700px;\n  line-height: normal;\n}\n\n/* ........................banner-end................. */\n\n/* ....................banner-section-2 start............. */\n.buildpan-icon {\n  background-color: #000;\n}\n\n.buildpanicon_main_wrapper {\n  padding: 60px 0 40px;\n}\n\n.buildpanicon_main_wrapper h2 {\n  text-align: center;\n  font-size: 16px;\n  line-height: normal;\n  font-weight: 400;\n  margin: 0 auto 50px;\n  padding: 0;\n  color: #fff;\n  width: 500px;\n  max-width: 100%;\n  font-family: \"Poppins\";\n}\n\n.buildpan-icons-wrapper {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n\n.buildpan_icons_inner {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  border: 1px dashed #3e3e3e;\n  background: #0c0c0c;\n  border-radius: 20px;\n  padding: 14px;\n  transform: scale(1);\n  transition: all 0.3s ease-in-out;\n}\n\n.buildpan_icons_inner:hover {\n  border: 1px dashed #707070;\n  background: #202020;\n  box-shadow: 0 0 15px #1c293a;\n  background: #000;\n  transform: scale(1.1);\n}\n\n.buildpan_icon {\n  max-width: 120px;\n  margin-bottom: 20px;\n  object-fit: contain;\n  width: 100%;\n}\n\n.buildpan_icon_text {\n  font-size: 17px;\n  font-weight: 400;\n  text-align: center;\n  color: #fff;\n  letter-spacing: 0.2px;\n  margin: 0;\n}\n\n.buildpan-card {\n  margin-bottom: 30px;\n}\n\n/* ........................banner-section2 end................... */\n\n/* .................................banner-section-3 start.................. */\n.ship-section-stats {\n  border-top: 1px solid rgb(233 233 233 / 80%);\n  border-bottom: 1px solid rgb(233 233 233 / 80%);\n  background-color: rgba(246, 246, 246, 0.799);\n  padding: 50px 0;\n}\n\n.ship-section-wrapper {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n}\n\n.ship-section-wrapper-item {\n  border-right: 1px solid #eaeaea;\n  padding: 0 0px;\n  text-align: center;\n  width: 25%;\n}\n\n.ship-section-wrapper-item:last-child {\n  border-right: none;\n}\n\n.ship-section-wrapper-item .highlight {\n  font-size: 54px;\n  font-family: Poppins;\n  font-weight: 600;\n  margin: 0;\n  color: #000;\n}\n\n.ship-section-wrapper-item .description {\n  font-size: 17px;\n  font-family: Poppins;\n  color: #000;\n}\n\n.ship-section-wrapper-item .meetourteam {\n  text-align: center;\n  margin-bottom: 30px;\n  font-size: 32px;\n}\n\n/* .................................banner-section-3 end.................. */\n\n/* ...........................banner-section-4-start...................... */\n\n.customer-logos {\n  padding-top: 30px;\n}\n\n.customer-logos img {\n  width: 100%;\n  height: 100px;\n  object-fit: contain;\n  margin: 0 auto;\n}\n\n.our-clients {\n  background-color: #fff;\n  border-bottom: 1px solid rgb(206 206 206 / 80%);\n  padding: 60px 0;\n}\n\n/* ...........................banner-section-4-end...................... */\n\n/* ....................................testimonials............................................. */\n\n.testimonials .slick-slide {\n  display: flex !important;\n  align-items: center;\n  justify-content: center;\n  height: inherit;\n}\n\n.testimonials .slick-dots {\n  position: relative;\n}\n\n.testimonials .slick-track {\n  transition: all 0.3s ease-in-out;\n}\n\n.testimonials .mySlides-para {\n  font-size: 18px;\n  font-weight: 400;\n  max-width: 600px;\n  font-family: Poppins;\n  margin-bottom: 30px;\n}\n\n.testimonials .text-bold {\n  font-size: 18px;\n  font-weight: 500;\n}\n\n.testimonials {\n  margin: 60px 0 60px;\n}\n\n.testimonials_heading {\n  text-align: center;\n  font-size: 35px;\n  margin: 0;\n}\n\n.testimonials .slick-prev:before {\n  background-image: url(../src/Images/left-arrow.svg) !important;\n  background-repeat: no-repeat;\n  color: rgba(0, 0, 0, 0);\n  font-size: 42px;\n  left: 0;\n  position: absolute;\n}\n\n.testimonials .slick-next:before {\n  background-image: url(../src/Images/right-arrow.svg) !important;\n  background-repeat: no-repeat;\n  color: rgba(0, 0, 0, 0);\n  font-size: 42px;\n  right: 0;\n  position: absolute;\n}\n\n.testimonials .slick-prev {\n  left: 0 !important;\n}\n\n.testimonials .slick-next {\n  right: 0 !important;\n}\n\n.testimonials .slick-slider {\n  padding: 0 50px;\n  text-align: center;\n  background: #fff;\n}\n\n/* ................testimonials-end-------------------------- */\n\n/* .......................footer-start.......................... */\n.footer {\n  padding: 45px 0;\n  background-color: #000;\n}\n\n.footer .bugfree {\n  margin-bottom: 40px;\n  border-bottom: 1px dashed #3e3e3e;\n  padding-bottom: 35px;\n}\n\n.footer .bugfree-inner {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.footer .bugfree-text {\n  padding: 0 15px;\n  font-size: 22px;\n  color: #fff;\n  font-family: sans-serif;\n}\n\n.footer .bugfree-text span {\n  font-weight: 600;\n}\n\n.footer .Start-btn {\n  padding: 12px 24px;\n  color: white;\n  border: 1px solid #fff;\n  border-radius: 50px;\n  margin-right: 15px;\n  text-decoration: none;\n}\n\n.footer .Start-btn:hover {\n  color: white;\n  text-decoration: none;\n}\n\n.footer .Request-demo {\n  padding: 12px 24px;\n  background-color: #fff;\n  color: black;\n  border-radius: 50px;\n  text-decoration: none;\n  font-size: 17px;\n}\n\n.footer .Request-demo:hover {\n  color: rgb(255, 255, 255);\n  color: black;\n  text-decoration: none;\n}\n\n.footer .footer-inner {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n}\n\n.footer .Workflow-wrapper {\n  width: 55%;\n}\n\n.footer .Workflow-heading {\n  font-size: 26px;\n  color: #fff;\n  margin-bottom: 20px;\n}\n\n.footer .Workflow-para {\n  font-size: 15px;\n  color: #fff;\n  line-height: 27px;\n}\n\n.footer .Workflow-para a {\n  color: #4ecdff;\n}\n\n.footer .footer-list a {\n  font-size: 15px;\n  color: #e5e5e5;\n  cursor: pointer;\n  line-height: 30px;\n  white-space: nowrap;\n  text-decoration: none;\n}\n\n.footer .footer-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.footer .footer-list a:hover {\n  color: #e5e5e5;\n  text-decoration: none;\n}\n\n.footer .social-list a {\n  width: 32px;\n  height: 32px;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n  text-decoration: none;\n  margin: 0 8px 0 0;\n}\n\n.footer .social-list a img {\n  width: 20px;\n  height: 20px;\n}\n\n.footer .social-list a i {\n  font-size: 14px;\n  color: #fff;\n}\n\n.footer .facebook-bg {\n  background: #4267b2;\n}\n\n.footer .twitter-bg {\n  background: #1da1f2;\n}\n\n.footer .instagram-bg {\n  background: #e4405f;\n}\n\n.footer .linkedin-bg {\n  background: #0072b1;\n}\n\n.footer .follow-us {\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 30px;\n  color: #fff;\n  margin-bottom: 15px;\n}\n\n/* ....................fotter-end............................... */\n\n/* .......................................login..................................... */\ninput[type=\"text\"],\ninput[type=\"email\"],\ninput[type=\"password\"] {\n  width: 100%;\n}\n\n.main-agileinfo {\n  margin: 0 auto;\n  width: 100%;\n  max-width: 530px;\n}\n\n.login-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  height: calc(100vh - 115px);\n}\n\n.login-wrapper .login-titles {\n  text-align: center;\n  margin-bottom: 35px;\n}\n\n.login-wrapper .login-titles h1 {\n  font-size: 32px;\n  font-weight: 600;\n  font-family: poppins;\n}\n\n.login-wrapper .login-titles p {\n  font-size: 16px;\n  font-weight: 400;\n  font-family: poppins;\n  color: black;\n  margin: 0;\n  letter-spacing: 0.3px;\n}\n\n.login-wrapper .sign-text {\n  font-size: 15px;\n  color: rgb(0, 0, 0);\n  text-align: center;\n  letter-spacing: 0.3px;\n  font-weight: 400;\n  margin: 0;\n  font-family: Poppins;\n}\n\n.login-wrapper .sign-text a {\n  color: rgb(0, 0, 0);\n  -webkit-transition: 0.5s all;\n  -moz-transition: 0.5s all;\n  transition: 0.5s all;\n  text-decoration: none;\n  font-weight: 400;\n}\n\n.login-wrapper .sign-text a:hover {\n  color: #000000;\n  text-decoration: none;\n}\n\n.login-wrapper :-ms-input-placeholder {\n  color: rgb(0, 0, 0);\n}\n\n.login-wrapper input[type=\"submit\"] {\n  font-size: 16px;\n  font-weight: 400;\n  color: rgb(255, 255, 255);\n  background: #000000;\n  outline: none;\n  border: 1px solid #000000;\n  padding: 11px 13px;\n  -webkit-appearance: none;\n  width: 100%;\n  margin: 25px 0;\n  letter-spacing: 4px;\n  border-radius: 4px;\n}\n\n.login-wrapper input[type=\"submit\"]:hover {\n  -webkit-transition: 0.5s all;\n  -moz-transition: 0.5s all;\n  -o-transition: 0.5s all;\n  -ms-transition: 0.5s all;\n  transition: 0.5s all;\n  background: #2b2b2b;\n  border: 1px solid #000000;\n  color: rgb(255, 255, 255);\n}\n\n.login-wrapper .login-forgotpw {\n  font-size: 14px;\n  color: rgb(0, 0, 0);\n  text-align: center;\n  letter-spacing: 0.3px;\n  font-family: poppins;\n  font-weight: 500;\n  text-decoration: none;\n}\n\n.login-wrapper .login-forgotpw:hover {\n  color: black;\n  text-decoration: none;\n}\n\n.login-wrapper .checkbox-text {\n  font-size: 15px;\n  color: rgb(0, 0, 0);\n  line-height: 24px;\n  margin: 0;\n  letter-spacing: 0.3px;\n  font-weight: 400;\n  font-family: poppins;\n}\n\n.login-wrapper .anim {\n  display: block;\n  position: relative;\n  padding-left: 27px;\n  margin: 7px 0 0 0;\n  cursor: pointer;\n  font-size: 22px;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.login-wrapper .anim input {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  height: 0;\n  width: 0;\n}\n\n.login-wrapper .checkmark {\n  position: absolute;\n  top: 3px;\n  left: 0;\n  height: 18px;\n  width: 18px;\n  background-color: #fff;\n  border: 1px solid;\n}\n\n.login-wrapper .anim:hover input~.checkmark {\n  background-color: #fff;\n  border: 1px solid;\n}\n\n.login-wrapper .contact-feild {\n  background: none !important;\n  padding: 11px 13px !important;\n  margin-bottom: 25px;\n  border: 1px solid #989898;\n  border-radius: 5px;\n}\n\n.login-wrapper .anim input:checked~.checkmark {\n  background-color: #000000;\n}\n\n.login-wrapper .checkmark:after {\n  content: \"\";\n  position: absolute;\n  display: none;\n}\n\n.login-wrapper .anim input:checked~.checkmark:after {\n  display: block;\n}\n\n.login-wrapper .anim .checkmark:after {\n  left: 5px;\n  top: 1px;\n  width: 6px;\n  height: 10px;\n  border: solid white;\n  border-width: 0 3px 3px 0;\n  -webkit-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n\n.login-wrapper input:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ninput:-webkit-autofill:active {\n  transition: background-color 5000s ease-in-out 0s;\n}\n\n/* ..............login-end------------------------- */\n\n/* ...................about -page.............................. */\n.about-banner .banner-img-wrapper {\n  position: relative;\n}\n\n.about-banner .bannerBg {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  z-index: -1;\n\n}\n\n.about-banner {\n  padding-bottom: 100px;\n  position: relative;\n}\n\n.about-banner .banner-text {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  text-align: center;\n}\n\n.about-banner .banner-text h2 {\n  font-family: \"Poppins\";\n  font-weight: 400;\n  font-size: 42px;\n  color: #ffffff;\n  margin-bottom: 10px;\n}\n\n.about-banner .banner-text p {\n  font-family: \"Poppins\";\n  font-weight: 400;\n  font-size: 16px;\n  line-height: normal;\n  color: #ffffff;\n  max-width: 500px;\n  margin: 0 auto;\n}\n\n.about-banner .banner-img {\n  position: relative;\n  padding-top: 20%;\n  width: 100%;\n  margin-bottom: 80px;\n}\n\n@media screen and (max-width:992px) {\n  .about-banner .banner-img {\n    padding-top: 35%;\n  }\n}\n\n.about-banner .banner-img img {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  object-fit: cover;\n}\n\n.about-banner .banner-bottom-text {\n  font-family: \"Poppins\";\n  font-weight: 400;\n  font-size: 16px;\n  line-height: normal;\n  color: #000000;\n  text-align: left;\n  margin: 0 auto;\n  max-width: 950px;\n}\n\n/* ..........story start.................. */\n.story-wrapper {\n  background: #000;\n  padding: 60px 0;\n  position: relative;\n}\n\n.story-wrapper .storyBg {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  z-index: 0;\n}\n\n.story-wrapper h2 {\n  font-family: \"Poppins\";\n  font-weight: 400;\n  font-size: 32px;\n  line-height: normal;\n  color: #ffffff;\n  margin-bottom: 12px;\n}\n\n.story-wrapper p {\n  font-family: \"Poppins\";\n  font-weight: 400;\n  font-size: 17px;\n  color: #fff;\n  margin-bottom: 30px;\n  line-height: normal;\n}\n\n.story-wrapper .story-right {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  padding: 60px;\n}\n\n/* ........story-end.............. */\n\n/* ................blog-start............. */\n.blog-wrapper {\n  padding: 100px 0;\n}\n\n.blog-wrapper img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.blog-wrapper .slick-next {\n  background: rgba(0, 0, 0, 0);\n  width: 25px;\n  height: 25px;\n  z-index: 1;\n  right: -20px;\n}\n\n.blog-wrapper .slick-next::before {\n  font-size: 30px;\n  color: #000;\n}\n\n.blog-wrapper .slick-prev {\n  background: rgba(0, 0, 0, 0);\n  width: 25px;\n  height: 25px;\n  left: auto;\n  right: 7px;\n  z-index: 1;\n}\n\n.blog-wrapper .slick-prev::before {\n  font-size: 30px;\n  color: #000;\n}\n\n.blog-wrapper h2 {\n  font-family: \"Poppins\";\n  font-weight: 400;\n  font-size: 28px;\n  line-height: normal;\n  color: #000000;\n  margin-bottom: 12px;\n}\n\n.blog-wrapper p {\n  font-family: \"Poppins\";\n  font-weight: 400;\n  font-size: 17px;\n  line-height: 27px;\n  color: #000000;\n  margin-bottom: 7px;\n}\n\n.blog-wrapper ul {\n  list-style: disc;\n}\n\n.blog-wrapper ul li {\n  font-family: \"Poppins\";\n  font-weight: 400;\n  font-size: 17px;\n  line-height: 26px;\n  color: #000000;\n}\n\n.blog-wrapper .blog-text {\n  padding-left: 60px;\n}\n\n/* .................blog-end............. */\n\n/* ............code-block-start......... */\n.code--block {\n  padding: 0 0 100px 0;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.code-slider {\n  position: absolute;\n  right: 0;\n  width: 50%;\n}\n\n.code-text {\n  width: 50%;\n  padding-right: 60px;\n}\n\n.code--block img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.code--block h2 {\n  font-family: \"Poppins\";\n  font-weight: 400;\n  font-size: 28px;\n  color: #000000;\n  margin-bottom: 12px;\n  line-height: normal;\n}\n\n.code--block p {\n  font-family: \"Poppins\";\n  font-size: 17px;\n  line-height: normal;\n  color: #000000;\n}\n\n.code--block .slick-initialized .slick-slide {\n  padding: 0 0 0 14px;\n}\n\n.code--block .slick-initialized .slick-slide div:focus-visible {\n  outline: 0;\n}\n\n.code--block img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 5px;\n}\n\n.code--block img:focus-visible {\n  outline: 0;\n}\n\n.code--block .slick-track {\n  padding: 0;\n}\n\n/* ..............code-block........end */\n\n/* ..............work-block start............ */\n.work-block {\n  background: #f3f5f6;\n  padding: 70px 0;\n  position: relative;\n}\n\n.work-block .bottomBg {\n  position: absolute;\n  bottom: 0;\n  z-index: 1;\n  width: 100%;\n}\n\n.work-block h2 {\n  font-family: \"Poppins\";\n  font-weight: 400;\n  font-size: 32px;\n  line-height: normal;\n  text-align: center;\n  color: #000000;\n  margin-bottom: 10px;\n}\n\n.work-block p {\n  font-family: \"Poppins\";\n  font-weight: 400;\n  font-size: 17px;\n  line-height: normal;\n  max-width: 800px;\n  margin: 0 auto 25px;\n  text-align: center;\n  color: #000000;\n}\n\n.learn-more {\n  max-width: 165px;\n  padding: 15px 25px;\n  margin: 0 auto;\n  width: 100%;\n  text-align: center;\n  background: #000;\n  border-radius: 5px;\n}\n\n.learn-more a {\n  font-family: \"Poppins\";\n  font-weight: 400;\n  font-size: 18px;\n  color: #fff;\n  text-decoration: none;\n  position: relative;\n  z-index: 1;\n}\n\n.learn-more a:hover {\n  color: #fff;\n}\n\n/* ................work-block end....................... */\n\n/* ...........................features-page...................... */\n.features-banner .banner-img-wrapper {\n  position: relative;\n}\n\n.features-banner .bannerBg {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  z-index: -1;\n}\n\n.features-banner {\n  padding-bottom: 50px;\n}\n\n.features-banner .banner-text {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  text-align: center;\n}\n\n.features-banner .banner-text h2 {\n  font-family: \"Poppins\";\n  font-weight: 400;\n  font-size: 42px;\n  color: #ffffff;\n  margin-bottom: 10px;\n  line-height: normal;\n}\n\n.features-banner .banner-text p {\n  font-family: \"Poppins\";\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 27px;\n  color: #ffffff;\n  margin: 0;\n}\n\n.features-banner .banner-img {\n  position: relative;\n  padding-top: 20%;\n  width: 100%;\n}\n\n@media screen and (max-width:992px) {\n  .features-banner .banner-img {\n    padding-top: 35%;\n  }\n}\n\n.features-banner .banner-img img {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  object-fit: cover;\n}\n\n.features-banner .banner-bottom-text {\n  font-family: \"Poppins\";\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 27px;\n  color: #000000;\n  text-align: center;\n  margin: 0 auto;\n  max-width: 860px;\n}\n\n/* .......................features-page end......................... */\n\n/* ..........features-wrapper-start....... */\n.features-wrapper .features-list {\n  padding: 100px 0;\n  position: relative;\n}\n\n.features-wrapper .features-block {\n  flex-direction: row-reverse;\n}\n\n.features-wrapper .features-list .right-bg {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n}\n\n.features-wrapper .features-list .left-bg {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n}\n\n.features-wrapper .features-list .top-bottom-bg {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  height: 100%;\n  width: 100%;\n}\n\n.features-wrapper .features-list .group-bg {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  width: 100%;\n}\n\n.features-wrapper .features-list:nth-child(2) {\n  background-color: #f3f5f6;\n}\n\n.features-wrapper .features-list:nth-child(4) {\n  background-color: #f3f5f6;\n}\n\n.features-wrapper .features-list:nth-child(6) {\n  background-color: #000000;\n  text-align: center;\n}\n\n.features-wrapper .features-list:nth-child(6) h3 {\n  font-family: Poppins;\n  font-weight: 400;\n  font-size: 50px;\n  line-height: 50px;\n  color: #ffffff;\n  margin-bottom: 25px;\n}\n\n.features-wrapper .features-list:nth-child(6) p {\n  font-family: Poppins;\n  font-weight: 400;\n  font-size: 17px;\n  color: #ffffff;\n}\n\n.features-wrapper .features-list:nth-child(8) {\n  background-color: #f3f5f6;\n  text-align: center;\n}\n\n.features-wrapper .features-list h3 {\n  font-family: Poppins;\n  font-weight: 400;\n  font-size: 28px;\n  line-height: normal;\n  color: #000000;\n  margin-bottom: 12px;\n}\n\n.features-wrapper .features-list p {\n  font-family: Poppins;\n  font-weight: 400;\n  font-size: 17px;\n  color: #000000;\n  margin-bottom: 30px;\n  line-height: normal;\n}\n\n.features-wrapper .features-list .featue-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  filter: drop-shadow(1px 1px 50px rgba(0, 0, 0, 0.1));\n}\n\n.features-wrapper .features-list .explore-btn {\n  max-width: 150px;\n  background: #000;\n  padding: 12px 15px;\n  border-radius: 5px;\n  text-align: center;\n}\n\n.features-wrapper .features-list .explore-btn a {\n  color: #fff;\n  text-decoration: none;\n  font-size: 16px;\n}\n\n.features-wrapper .features-list:first-child .featue-img {\n  padding-left: 50px;\n}\n\n.features-wrapper .features-list:nth-child(2) .featue-img {\n  padding-right: 50px;\n}\n\n.features-wrapper .features-list:nth-child(3) .featue-img {\n  padding-left: 50px;\n}\n\n.features-wrapper .features-list:nth-child(4) .featue-img {\n  padding-right: 50px;\n}\n\n.features-wrapper .features-list:nth-child(5) .featue-img {\n  padding-left: 50px;\n}\n\n.features-wrapper .features-list:nth-child(7) .featue-img {\n  padding-left: 50px;\n}\n\n/* .............features-wrapper-end......... */\n\n/* .......................blog-start....................... */\n.blog-banner .banner-img-wrapper {\n  position: relative;\n}\n\n.blog-banner .bannerBg {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  z-index: -1;\n}\n\n.blog-banner .banner-text {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  text-align: center;\n}\n\n.blog-banner .banner-text h2 {\n  font-family: \"Poppins\";\n  font-weight: 400;\n  font-size: 42px;\n  line-height: normal;\n  color: #ffffff;\n  margin-bottom: 10px;\n}\n\n.blog-banner .banner-text p {\n  font-family: \"Poppins\";\n  font-weight: 400;\n  font-size: 17px;\n  line-height: normal;\n  color: #ffffff;\n  margin: 0;\n}\n\n.blog-banner .banner-img {\n  position: relative;\n  padding-top: 20%;\n  width: 100%;\n}\n\n@media screen and (max-width:767px) {\n  .blog-banner .banner-img {\n    padding-top: 65% !important;\n  }\n}\n\n.blog-banner .banner-img img {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  object-fit: cover;\n}\n\n.cicd-block img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.cicd-block ul {\n  list-style: disc;\n}\n\n.cicd-block ul li {\n  font-family: \"Poppins\";\n  font-weight: 400;\n  font-size: 17px;\n  line-height: normal;\n  color: #000000;\n}\n\n.cicd-block {\n  padding: 80px 0;\n}\n\n.cicd-pipeline {\n  padding: 20px 0 80px;\n}\n\n.cicd-pipeline h2 {\n  font-family: \"Poppins\";\n  font-weight: 400;\n  font-size: 28px;\n  list-style: normal;\n  color: #000000;\n  margin-bottom: 12px;\n}\n\n.cicd-pipeline p {\n  font-family: \"Poppins\";\n  font-weight: 400;\n  font-size: 17px;\n  line-height: normal;\n  color: #000000;\n}\n\n.cicd-pipeline .cicd-slider {\n  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.15));\n  background: #fff;\n  padding: 37px 0 58px 37px;\n  border-radius: 10px;\n}\n\n.cicd-pipeline .cicd-slider h4 {\n  font-family: \"Poppins\";\n  font-weight: 400;\n  font-size: 22px;\n  line-height: normal;\n  margin-bottom: 15px;\n  color: #000000;\n}\n\n.cicd-pipeline .cicd-slider p {\n  font-family: \"Poppins\";\n  font-weight: 500;\n  font-size: 16px;\n  color: #000000;\n  margin-top: 7px;\n}\n\n.cicd-pipeline .cicd-slider img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 10px;\n}\n\n.cicd-pipeline .cicd-slider .slick-initialized .slick-slide {\n  padding: 0 0 0 14px;\n}\n\n.cicd-pipeline .cicd-slider .slick-initialized .slick-slide div:focus-visible {\n  outline: 0;\n}\n\n.cicd-pipeline .cicd-slider .slick-track {\n  padding: 0;\n}\n\n.article-wrapper {\n  padding-bottom: 50px;\n}\n\n.article-wrapper h2 {\n  font-family: \"Poppins\";\n  font-weight: 400;\n  font-size: 32px;\n  color: #000000;\n  text-align: center;\n  margin-bottom: 40px;\n}\n\n.article-wrapper .article-img {\n  position: relative;\n  padding-top: 60%;\n  width: 100%;\n}\n\n.article-wrapper .article-img img {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  object-fit: cover;\n  border-radius: 10px;\n}\n\n.article-wrapper .card {\n  margin-bottom: 40px;\n  padding: 15px;\n  border: none;\n  box-shadow: 1px 1px 50px rgba(0, 0, 0, 0.15);\n  border-radius: 10px;\n  text-decoration: none;\n}\n\n.article-wrapper .article-text {\n  text-align: left;\n  margin-top: 20px;\n}\n\n.article-wrapper .article-text h4 {\n  font-family: \"Poppins\";\n  font-weight: 600;\n  font-size: 14px;\n  color: #0950bb;\n  margin-bottom: 20px;\n}\n\n.article-wrapper .article-text p {\n  font-family: \"Poppins\";\n  font-weight: 400;\n  font-size: 18px;\n  color: #000000;\n}\n\n.stay-up-block .mail-input {\n  display: flex;\n  align-items: center;\n  background: #fff;\n  border-radius: 5px;\n  padding: 10px 10px 10px 23px;\n  position: relative;\n  z-index: 1;\n}\n\n.stay-up-block .mail-input img {\n  width: 28px;\n  object-fit: contain;\n  height: 28px;\n}\n\n.stay-up-block .mail-input button {\n  background: #000;\n  color: #fff;\n  padding: 6px 40px;\n  border-radius: 5px;\n}\n\n.stay-up-block .mail-input input {\n  border: none;\n  background: rgba(255, 255, 255, 0);\n  padding: 0;\n}\n\n.stay-up-block .mail-input input:focus-visible {\n  outline: none;\n}\n\n.stay-up-block {\n  background: #f3f5f6;\n  padding: 80px 0 80px;\n  position: relative;\n}\n\n.stay-up-block .group-bg {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  width: 100%;\n}\n\n.stay-up-block h2 {\n  font-family: \"Poppins\";\n  font-weight: 400;\n  font-size: 28px;\n  line-height: normal;\n  color: #000000;\n  margin-bottom: 12px;\n}\n\n.stay-up-block p {\n  font-family: \"Poppins\";\n  font-weight: 400;\n  font-size: 17px;\n  line-height: normal;\n  color: #000000;\n}\n\n/* .........................blog-end.................. */\n\n/* ..........................blog-view start................ */\n.blog-view-banner .date {\n  display: flex;\n  align-items: center;\n}\n\n.blog-pagination .pagination {\n  justify-content: center;\n}\n\n.blog-pagination .pagination a {\n  color: #000;\n}\n\n.blog-view-banner h2 {\n  font-family: \"Poppins\";\n  font-weight: 400;\n  font-size: 42px;\n  padding-right: 20px;\n  line-height: 60px;\n  color: #000000;\n  margin-bottom: 20px;\n}\n\n.blog-view-banner .date img {\n  width: 35px;\n  height: 35px;\n  object-fit: contain;\n  margin-right: 13px;\n}\n\n.blog-view-banner .date p {\n  margin: 0;\n  font-family: \"Poppins\";\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 36px;\n  color: #898989;\n}\n\n.blog-view-banner .right-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 10px;\n}\n\n.blog-view-banner {\n  padding: 50px 0;\n  border-bottom: 1px solid #ececec;\n}\n\n.blog-view-text h4 {\n  font-family: \"Poppins\";\n  font-weight: 600;\n  font-size: 14px;\n  color: #0950bb;\n  margin-bottom: 30px;\n}\n\n.blog-view-text p {\n  font-family: \"Poppins\";\n  font-weight: 400;\n  font-size: 18px;\n  color: #000000;\n  margin-bottom: 30px;\n  text-align: justify;\n}\n\n.blog-view-text {\n  padding: 40px 0 50px;\n}\n\n.article-slider h2 {\n  font-family: \"Poppins\";\n  font-weight: 400;\n  font-size: 50px;\n  color: #000000;\n  text-align: center;\n  margin-bottom: 40px;\n}\n\n.article-slider .slick-track {\n  padding: 0;\n}\n\n.article-slider .card {\n  margin-bottom: 40px;\n  padding: 15px;\n  border: none;\n  border-radius: 10px;\n  text-decoration: none;\n}\n\n.article-slider .blog-text {\n  text-align: left;\n  margin-top: 20px;\n}\n\n.article-slider .card h4 {\n  font-family: \"Poppins\";\n  font-weight: 600;\n  font-size: 14px;\n  color: #0950bb;\n  margin-bottom: 20px;\n}\n\n.article-slider .card p {\n  font-family: \"Poppins\";\n  font-weight: 400;\n  font-size: 18px;\n  color: #000000;\n}\n\n.article-slider img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 10px;\n}\n\n.article-slider .article-list {\n  padding: 0 15px;\n}\n\n.article-slider {\n  padding: 50px 0 80px;\n}\n\n/* ............................blog-view-end................. */\n\n/*.....................career-start...................  */\n.career-banner .banner-img-wrapper {\n  position: relative;\n}\n\n.career-banner .bannerBg {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  z-index: -1;\n}\n\n.career-banner .banner-text {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  text-align: center;\n}\n\n.career-banner .banner-text h2 {\n  font-family: \"Poppins\";\n  font-weight: 400;\n  font-size: 42px;\n  line-height: normal;\n  color: #ffffff;\n  margin-bottom: 12px;\n}\n\n.career-banner .banner-text p {\n  font-family: \"Poppins\";\n  font-weight: 400;\n  font-size: 17px;\n  line-height: normal;\n  color: #ffffff;\n  margin: 0;\n}\n\n.career-banner .banner-img {\n  position: relative;\n  padding-top: 20%;\n  width: 100%;\n}\n\n@media screen and (max-width:767px) {\n  .career-banner .banner-img {\n    padding-top: 65% !important;\n  }\n}\n\n.career-banner .banner-img img {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  object-fit: cover;\n}\n\n.jobs-details h3 {\n  font-family: \"Poppins\";\n  font-weight: 500;\n  font-size: 26px;\n  line-height: 30px;\n  color: #000000;\n  margin-bottom: 20px;\n}\n\n.jobs-details .jobs-list {\n  max-width: 700px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n.jobs-details .jobs-list .jobs-item {\n  padding: 25px 38px;\n  border-bottom: 1px solid #d9d9d9;\n  position: relative;\n}\n\n.jobs-details {\n  padding: 70px 0;\n}\n\n.jobs-list p {\n  margin: 0;\n  font-size: 17px;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.jobs-details .jobs-list .jobs-item h4 {\n  font-family: \"Poppins\";\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 28px;\n  color: #000000;\n}\n\n.jobs-details .jobs-list .jobs-item p {\n  font-family: \"Poppins\";\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 28px;\n  color: #000000;\n}\n\n.jobs-details .jobs-list .jobs-item .explore-btn {\n  max-width: 150px;\n  background: rgb(255, 255, 255);\n  border: 2px solid #b7b7b7;\n  padding: 12px 15px;\n  border-radius: 5px;\n  text-align: center;\n  margin: 0 0 0 auto;\n}\n\n.jobs-details .jobs-list .jobs-item .explore-btn a {\n  color: #939393;\n  font-size: 15px;\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.career-pagination {\n  margin: 50px 0;\n}\n\n.career-pagination .pagination {\n  justify-content: center;\n}\n\n.career-pagination .pagination .page-link {\n  color: #000;\n}\n\n.jobs-details .jobs-list .jobs-item:hover {\n  border-color: transparent;\n  background: #f6f6f6;\n}\n\n.jobs-details .jobs-list .jobs-item:hover::before {\n  opacity: 1;\n}\n\n.jobs-details .jobs-list .jobs-item::before {\n  content: '';\n  height: 100%;\n  width: 4px;\n  background: #000000;\n  position: absolute;\n  left: 0;\n  top: 0;\n  opacity: 0;\n  transition: all .3s ease-in-out;\n}\n\n.jobs-details .jobs-list .jobs-item.active .explore-btn {\n  background: #000;\n  border: 1px solid #000;\n}\n\n.jobs-details .jobs-list .jobs-item.active .explore-btn a {\n  color: #fff;\n}\n\n/* ....................career-end................... */\n\n/* ..........................casestudy start............... */\n.case-study-list img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  filter: drop-shadow(1px 1px 50px rgba(0, 0, 0, 0.15));\n  border-radius: 10px;\n}\n\n.case-study-block {\n  flex-direction: row-reverse;\n}\n\n.case-study-text h4 {\n  font-family: \"Poppins\";\n  font-weight: 400;\n  font-size: 28px;\n  line-height: normal;\n  color: #000000;\n  max-width: 480px;\n  margin-bottom: 20px;\n}\n\n@media screen and (max-width:992px) {\n  .case-study-text h4 {\n    max-width: 100%;\n  }\n}\n\n.case-study-text .read-more {\n  max-width: 150px;\n  background: #000;\n  padding: 12px 15px;\n  border-radius: 5px;\n  text-align: center;\n}\n\n.read-more {\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.case-study-text {\n  padding-right: 60px;\n}\n\n.case-study-block .case-study-text {\n  padding-left: 60px;\n  padding-right: 0;\n}\n\n.case-study-text .read-more a {\n  color: #fff;\n  text-decoration: none;\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.casestudy-banner .banner-img-wrapper {\n  position: relative;\n}\n\n.casestudy-banner .bannerBg {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  z-index: -1;\n}\n\n.casestudy-banner {\n  padding-bottom: 50px;\n}\n\n.casestudy-banner .banner-text {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  text-align: center;\n}\n\n@media screen and (max-width:767px) {\n\n  .casestudy-banner .banner-text,\n  .pricing-banner .banner-text,\n  .blog-banner .banner-text,\n  .career-banner .banner-text,\n  .features-banner .banner-text,\n  .about-banner .banner-text {\n    width: 100%;\n    padding: 15px;\n  }\n}\n\n.casestudy-banner .banner-text h2 {\n  font-family: \"Poppins\";\n  font-weight: 400;\n  font-size: 42px;\n  line-height: normal;\n  color: #ffffff;\n  margin-bottom: 12px;\n}\n\n.casestudy-banner .banner-text p {\n  font-family: \"Poppins\";\n  font-weight: 400;\n  font-size: 17px;\n  line-height: normal;\n  color: #ffffff;\n  margin: 0;\n}\n\n.casestudy-banner .banner-img {\n  position: relative;\n  padding-top: 20%;\n  width: 100%;\n}\n\n@media screen and (max-width:767px) {\n  .casestudy-banner .banner-img {\n    padding-top: 65% !important;\n  }\n}\n\n.casestudy-banner .banner-img img {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  object-fit: cover;\n}\n\n.case-study-wrapper .case-study-list {\n  padding: 50px 0;\n}\n\n.case-study-wrapper {\n  padding-bottom: 50px;\n}\n\n/* .............................casestudy-end............... */\n\n/* ..............pricing-start................. */\n.pricing-banner .banner-img-wrapper {\n  position: relative;\n}\n\n.pricing-banner .bannerBg {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  z-index: -1;\n}\n\n.pricing-banner {\n  padding-bottom: 40px;\n}\n\n.pricing-banner .banner-text {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  text-align: center;\n}\n\n.pricing-banner .banner-text h2 {\n  font-family: \"Poppins\";\n  font-weight: 400;\n  font-size: 32px;\n  line-height: normal;\n  color: #ffffff;\n  margin-bottom: 12px;\n}\n\n.pricing-banner .banner-text p {\n  font-family: \"Poppins\";\n  font-weight: 400;\n  font-size: 17px;\n  line-height: normal;\n  color: #ffffff;\n  margin: 0;\n}\n\n.pricing-banner .banner-img {\n  position: relative;\n  padding-top: 20%;\n  width: 100%;\n  background-image: url(../src/Images/black-bg.png);\n}\n\n.pricing-banner .banner-img img {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  object-fit: cover;\n}\n\n.pricing-wrapper .pricing-card {\n  background: #f3f5f6;\n  padding: 50px 30px 76px 30px;\n  text-align: center;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n@media screen and (max-width:992px) {\n  .pricing-wrapper .pricing-card {\n    padding: 50px 15px;\n  }\n}\n\n.pricing-wrapper .pricing-card h4 {\n  font-family: \"Poppins\";\n  font-weight: 500;\n  font-size: 24px;\n  margin-bottom: 25px;\n  text-align: center;\n  color: #000000;\n}\n\n.pricing-wrapper .pricing-card h1 {\n  font-family: \"Poppins\";\n  font-weight: 600;\n  font-size: 52px;\n  line-height: 60px;\n  text-align: center;\n  color: #000000;\n}\n\n.pricing-wrapper .pricing-card h1 span {\n  font-size: 23px;\n}\n\n.pricing-wrapper .pricing-card p {\n  font-family: \"Poppins\";\n  font-weight: 400;\n  font-size: 17px;\n  line-height: normal;\n  text-align: center;\n  color: #000000;\n  margin: 0;\n}\n\n.pricing-wrapper .pricing-card .read-more {\n  max-width: 175px;\n  font-size: 14px;\n  font-weight: 400;\n  background: black;\n  padding: 11px 35px;\n  text-align: center;\n  border-radius: 5px;\n  margin: 40px auto 0;\n}\n\n.pricing-wrapper .pricing-card .read-more a {\n  color: #fff;\n  text-decoration: none;\n}\n\n.pricing-wrapper .pricing-card:hover {\n  background: #000;\n}\n\n.pricing-wrapper .pricing-card:hover h4 {\n  color: #fff;\n}\n\n.pricing-wrapper .pricing-card:hover h1 {\n  color: #fff;\n}\n\n.pricing-wrapper .pricing-card:hover p {\n  color: #fff;\n}\n\n.pricing-wrapper .pricing-card:hover .read-more {\n  background: #fff;\n}\n\n.pricing-wrapper .pricing-card:hover .read-more a {\n  color: #000;\n  font-weight: 500;\n}\n\n.pricing-wrapper {\n  padding: 50px 0 90px;\n}\n\n/* ...........pricing-end.................. */\n\n/* ...............media. start.................................... */\n@media screen and (max-width: 767px) {\n\n  /* .enhance {\n    font-family: Poppins;\n    font-weight: 800;\n    line-height: 60px;\n    color: black;\n    font-size: 55px;\n    display: block;\n  }\n\n  .your {\n    font-family: Poppins;\n    font-weight: 800;\n    line-height: 50px;\n    color: black;\n    font-size: 55px;\n    display: block;\n  }\n\n  .productivity {\n    font-family: Poppins;\n    font-weight: 800;\n    line-height: 60px;\n    color: black;\n    font-size: 55px;\n    display: block;\n  } */\n  .about-banner .banner-text h2 {\n    font-size: 35px;\n    margin-bottom: 10px;\n  }\n\n  .about-banner .banner-text p {\n    font-size: 16px;\n    line-height: 23px;\n  }\n\n  .about-banner .banner-img {\n    padding-top: 65%;\n    margin-bottom: 55px;\n  }\n\n  .our-clients {\n    padding: 50px 0;\n  }\n\n  .about-banner .banner-bottom-text {\n    font-size: 16px;\n    line-height: 25px;\n  }\n\n  .about-banner {\n    padding-bottom: 45px;\n  }\n\n  .story-wrapper {\n    padding: 50px 0;\n    text-align: center;\n  }\n\n  .story-wrapper h2 {\n    font-size: 35px;\n  }\n\n  .story-wrapper p {\n    font-size: 16px;\n    line-height: 27px;\n  }\n\n  .story-wrapper .story-right {\n    padding: 30px;\n  }\n\n  .about-banner .bannerBg {\n    display: none;\n  }\n\n  .story-wrapper .storyBg {\n    display: none;\n  }\n\n  .blog-wrapper {\n    padding: 80px 0 50px;\n  }\n\n  .blog-wrapper .blog-text {\n    padding: 0 15px;\n    margin-top: 40px;\n  }\n\n  .blog-wrapper p {\n    font-size: 16px;\n    line-height: 27px;\n  }\n\n  .code--block {\n    padding: 30px 0 50px;\n    text-align: center;\n  }\n\n  .code--block p {\n    font-size: 17px;\n    margin: 0;\n  }\n\n  .code--block h2 {\n    font-size: 35px;\n  }\n\n  .work-block h2 {\n    font-size: 35px;\n    line-height: 35px;\n  }\n\n  .work-block p {\n    font-size: 17px;\n  }\n\n  .features-banner .banner-text h2 {\n    font-size: 35px;\n    margin-bottom: 8px;\n  }\n\n  .features-banner .banner-text p {\n    font-size: 16px;\n    line-height: 24px;\n  }\n\n  .features-wrapper .features-list p {\n    margin-bottom: 30px;\n  }\n\n  .features-wrapper .features-block {\n    flex-direction: row;\n  }\n\n  .features-wrapper .features-list h3 {\n    font-size: 35px;\n    margin-bottom: 10px;\n  }\n\n  .features-wrapper .features-list:nth-child(6) h3 {\n    font-size: 35px;\n    margin-bottom: 10px;\n  }\n\n  .features-wrapper .features-list {\n    padding: 40px 0;\n  }\n\n  .blog-view-banner h2 {\n    font-size: 33px;\n    line-height: 50px;\n    padding-right: 0;\n  }\n\n  .blog-view-text p {\n    font-size: 16px;\n  }\n\n  .article-slider h2 {\n    font-size: 33px;\n    margin-bottom: 20px;\n  }\n\n  .blog-view-text {\n    padding: 30px 0 0;\n  }\n\n  .blog-banner .banner-text h2 {\n    font-size: 33px;\n  }\n\n  .blog-banner .banner-text p {\n    font-size: 16px;\n    line-height: 24px;\n  }\n\n  .cicd-block ul li {\n    font-size: 16px;\n  }\n\n  .cicd-block {\n    padding: 50px 0;\n  }\n\n  .cicd-pipeline h2 {\n    font-size: 33px;\n  }\n\n  .cicd-pipeline p {\n    font-size: 16px;\n  }\n\n  .article-wrapper h2 {\n    font-size: 33px;\n    margin-bottom: 30px;\n  }\n\n  .stay-up-block {\n    padding: 50px 0;\n  }\n\n  .article-wrapper .article-text {\n    text-align: center;\n  }\n\n  .stay-up-block h2 {\n    font-size: 30px;\n    margin-bottom: 13px;\n  }\n\n  .career-banner .banner-text h2 {\n    font-size: 33px;\n    margin-bottom: 10px;\n  }\n\n  .career-banner .banner-text p {\n    font-size: 16px;\n    line-height: 23px;\n  }\n\n  .jobs-details .jobs-list .jobs-item {\n    padding: 25px;\n  }\n\n  .jobs-details .jobs-list .jobs-item p {\n    line-height: 24px;\n    font-size: 15px;\n  }\n\n  .stay-up-block p {\n    font-size: 16px;\n  }\n\n  .casestudy-banner .banner-text h2 {\n    font-size: 33px;\n    margin-bottom: 10px;\n  }\n\n  .casestudy-banner .banner-text p {\n    font-size: 16px;\n    line-height: 23px;\n  }\n\n  .casestudy-banner {\n    padding-bottom: 30px;\n  }\n\n  .case-study-wrapper .case-study-list {\n    padding: 30px 0;\n  }\n\n  .case-study-text h4 {\n    font-size: 30px;\n    line-height: 45px;\n  }\n\n  .pricing-banner .banner-text h2 {\n    font-size: 33px;\n    margin-bottom: 10px;\n  }\n\n  .pricing-banner .banner-text p {\n    font-size: 16px;\n    line-height: 24px;\n  }\n\n  .pricing-banner .banner-img {\n    padding-top: 80% !important;\n  }\n\n  .pricing-wrapper .pricing-card {\n    padding: 35px 30px 50px;\n  }\n\n  .pricing-wrapper {\n    padding: 20px 0 30px;\n  }\n\n  .pricing-wrapper .pricing-card h4 {\n    margin-bottom: 40px;\n  }\n\n  .features-banner .banner-img {\n    padding-top: 65%;\n  }\n\n  .banner-button-inner {\n    gap: 10px;\n  }\n\n  .building-btn {\n    padding: 10px 10px;\n    margin: 0;\n    min-width: 97px;\n  }\n\n  .ship-section-stats {\n    padding: 25px 0;\n  }\n\n  .footer {\n    padding: 25px 0;\n    text-align: center;\n  }\n\n  .bugfree {\n    padding-bottom: 40px;\n  }\n\n  .Start-btn {\n    width: 100%;\n    text-align: center;\n    margin-bottom: 15px;\n    margin-right: 0;\n  }\n\n  .Request-demo {\n    width: 100%;\n    text-align: center;\n  }\n\n  .Workflow-wrapper {\n    width: 100% !important;\n    margin-bottom: 40px;\n    padding-right: 0 !important;\n    text-align: center;\n  }\n\n  .footer .Workflow-para {\n    margin-bottom: 25px;\n  }\n\n  .footer .bugfree-text {\n    margin-bottom: 20px;\n  }\n\n\n}\n\n@media screen and (max-width: 992px) {\n  .header {\n    padding: 10px 0;\n  }\n\n  .blog-wrapper .slick-next {\n    right: 5px;\n  }\n\n  .blog-wrapper .slick-prev {\n    right: auto;\n  }\n\n  .ship-section-wrapper-item {\n    padding: 8px 10px;\n    text-align: center;\n    width: 50%;\n  }\n\n  .ship-section-wrapper-item:nth-child(2) {\n    border-bottom: 1px solid #eaeaea;\n    border-right: none;\n  }\n\n  .ship-section-wrapper-item:first-child {\n    border-bottom: 1px solid #eaeaea;\n  }\n\n  .ship-section-wrapper-item .highlight {\n    margin: 0;\n    font-size: 37px;\n  }\n\n  .features-wrapper .features-list .featue-img {\n    padding-top: 40px;\n  }\n\n  .features-wrapper .features-list .left-bg {\n    display: none;\n  }\n\n  .features-wrapper .features-list .right-bg {\n    display: none;\n  }\n\n  .features-wrapper .features-list .top-bottom-bg {\n    display: none;\n  }\n\n  .features-wrapper .features-list .group-bg {\n    display: none;\n  }\n\n  .stay-up-block .group-bg {\n    display: none;\n  }\n\n  .features-banner {\n    padding-bottom: 20px;\n  }\n\n  .features-wrapper {\n    text-align: center;\n  }\n\n  .features-wrapper .features-list .explore-btn {\n    margin: 0 auto;\n  }\n\n  .features-wrapper .features-list:first-child .featue-img {\n    padding-left: 0;\n  }\n\n  .features-wrapper .features-list:nth-child(2) .featue-img {\n    padding-right: 0;\n  }\n\n  .features-wrapper .features-list:nth-child(3) .featue-img {\n    padding-left: 0;\n  }\n\n  .features-wrapper .features-list:nth-child(4) .featue-img {\n    padding-right: 0;\n  }\n\n  .features-wrapper .features-list:nth-child(5) .featue-img {\n    padding-left: 0;\n  }\n\n  .features-wrapper .features-list:nth-child(7) .featue-img {\n    padding-left: 0;\n  }\n\n  .blog-view-banner .right-img {\n    margin-top: 40px;\n  }\n\n  .blog-view-text {\n    text-align: center;\n  }\n\n  .blog-view-banner h2 {\n    text-align: center;\n  }\n\n  .blog-view-banner .date {\n    justify-content: center;\n  }\n\n  .blog-banner .banner-img {\n    padding-top: 35%;\n  }\n\n  .cicd-block img {\n    margin-bottom: 50px;\n  }\n\n  .cicd-block {\n    text-align: center;\n  }\n\n  .cicd-pipeline {\n    text-align: center;\n  }\n\n  .stay-up-block {\n    text-align: center;\n  }\n\n  .code-text {\n    width: 100%;\n    padding: 0;\n    text-align: center;\n  }\n\n  .code-slider {\n    width: 100%;\n    position: unset;\n    margin-bottom: 40px;\n  }\n\n  .code-slider .slick-track {\n    padding: 0;\n  }\n\n  .code-slider .slick-track {\n    display: flex;\n    height: inherit;\n  }\n\n  .blog-wrapper h2 {\n    text-align: center;\n    line-height: 45px;\n  }\n\n  .story-wrapper {\n    text-align: center;\n  }\n\n  .blog-wrapper img {\n    margin-bottom: 50px;\n  }\n\n  .career-banner .banner-img {\n    padding-top: 35%;\n  }\n\n  .case-study-block .case-study-text {\n    padding-bottom: 50px;\n    padding-left: 0;\n    padding-right: 0;\n    text-align: center;\n  }\n\n  .case-study-text {\n    padding-bottom: 50px;\n    text-align: center;\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n  .case-study-text .read-more {\n    margin: 0 auto;\n  }\n\n  .case-study-block {\n    flex-direction: row;\n  }\n\n  .casestudy-banner .banner-img {\n    padding-top: 35%;\n  }\n\n  .pricing-banner .banner-img {\n    padding-top: 35%;\n  }\n\n  .pricing-wrapper .col-lg-4 {\n    margin-bottom: 40px;\n  }\n}\n\n/* ...............media. end.................................... */\n@media screen and (min-width: 768px) {\n  .testimonials .slick-track {\n    display: flex;\n  }\n}\n\n@media (min-width: 1025px) {\n\n\n  .menu-list li {\n    display: inline-block;\n    padding: 0 13px;\n  }\n\n  .menu-list li a {\n    color: #000;\n    text-decoration: none;\n    font-size: 15px;\n    font-family: \"Poppins\";\n    font-weight: 600;\n    cursor: pointer;\n    text-transform: uppercase;\n  }\n\n  .card-inner {\n    width: 31%;\n    padding: 50px 30px;\n    min-height: 265px;\n  }\n\n  .card-inner a {\n    bottom: -17px;\n    width: 33%;\n  }\n}\n\n@keyframes colorEnhance {\n  0% {\n    color: #000000;\n    animation-timing-function: ease-in-out;\n  }\n\n  20% {\n    color: #000000;\n    animation-timing-function: ease-in-out;\n  }\n\n  25% {\n    color: #0391c9;\n    animation-timing-function: ease-in-out;\n  }\n\n  40% {\n    color: #0391c9;\n    animation-timing-function: ease-in-out;\n  }\n\n  45% {\n    color: #000000;\n    animation-timing-function: ease-in-out;\n  }\n\n  100% {\n    color: #000000;\n    animation-timing-function: ease-in-out;\n  }\n}\n\n.enhanceText {\n  animation: colorEnhance 13s linear infinite;\n}\n\n@keyframes colorYour {\n  0% {\n    color: #000000;\n    animation-timing-function: ease-in-out;\n  }\n\n  40% {\n    color: #000000;\n    animation-timing-function: ease-in-out;\n  }\n\n  45% {\n    color: #cc0055;\n    animation-timing-function: ease-in-out;\n  }\n\n  60% {\n    color: #cc0055;\n    animation-timing-function: ease-in-out;\n  }\n\n  65% {\n    color: #000000;\n    animation-timing-function: ease-in-out;\n  }\n\n  100% {\n    color: #000000;\n    animation-timing-function: ease-in-out;\n  }\n}\n\n.yourText {\n  animation: colorYour 13s linear infinite;\n}\n\n@keyframes colorProduct {\n  0% {\n    color: #000000;\n    animation-timing-function: ease-in-out;\n  }\n\n  40% {\n    color: #000000;\n    animation-timing-function: ease-in-out;\n  }\n\n  41% {\n    color: #000000;\n    animation-timing-function: ease-in-out;\n  }\n\n  60% {\n    color: #000000;\n    animation-timing-function: ease-in-out;\n  }\n\n  65% {\n    color: #f1982e;\n    animation-timing-function: ease-in-out;\n  }\n\n  80% {\n    color: #f1982e;\n    animation-timing-function: ease-in-out;\n  }\n\n  85% {\n    color: #000000;\n    animation-timing-function: ease-in-out;\n  }\n\n  100% {\n    color: #000000;\n    animation-timing-function: ease-in-out;\n  }\n}\n\n.productText {\n  animation: colorProduct 13s linear infinite;\n}\n\n.terms_conditions-wrapper {\n  padding: 60px 0;\n}\n\n@media screen and (max-width:767px) {\n  .terms_conditions-wrapper {\n    padding: 50px 0;\n  }\n}\n\n.terms_conditions-wrapper .heading {\n  font-size: 32px;\n  font-weight: 500;\n  margin-bottom: 35px;\n  line-height: normal;\n}\n\n@media screen and (max-width:767px) {\n  .terms_conditions-wrapper .heading {\n    font-size: 28px;\n    text-align: center;\n  }\n}\n\n.address-block {\n  display: flex;\n  justify-content: center;\n  gap: 40px;\n}\n\n.contact-img {\n  width: 100%;\n  height: 300px;\n  margin-bottom: 20px;\n}\n\n.contact-img img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n@media screen and (max-width:767px) {\n  .contact-details {\n    margin-bottom: 25px;\n    text-align: center;\n  }\n}\n\n.contact-details h6 {\n  font-size: 25px;\n  font-weight: 500;\n  color: #000;\n  margin-bottom: 15px;\n}\n\n.contact-details p {\n  margin-bottom: 5px;\n  font-size: 16px;\n  font-weight: 400;\n  color: #000;\n}\n\n.faqs-block .accordion-button:not(.collapsed) {\n  background: #000;\n  color: #fff;\n  box-shadow: none;\n}\n\n.faqs-block .accordion-button:not(.collapsed)::after {\n  background-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23ffffff'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !important;\n}\n\n.faqs-block .accordion-button:focus {\n  box-shadow: none;\n}\n\n.faqs-block .accordion-body {\n  font-size: 16px;\n  font-weight: 400;\n  color: #000;\n}\n\n.faqs-block .accordion-button {\n  font-size: 16px;\n  font-weight: 400;\n}\n\n.navbar-expand-lg .container-fluid.navbar-nav {\n  flex-direction: row;\n}\n\n.about-banner-container .banner-text h2 {\n  font-weight: 600;\n  margin-bottom: 15px;\n}\n\n.about-banner-container .banner-text h6 {\n  font-size: 40px;\n  font-weight: 600;\n  color: #4874EB;\n  margin: 0;\n}\n\n@media screen and (max-width:767px) {\n  .about-banner-container .banner-text h6 {\n    font-size: 28px;\n  }\n}\n\n.about-banner-container .banner-text h6 span {\n  color: #EE9D3A;\n}\n\n.about-banner-container {\n  padding: 80px 0;\n}\n\n.about-para {\n  margin: 20px 0;\n}\n\n.about-para p {\n  font-size: 16px;\n  font-weight: 400;\n  color: #000;\n  margin: 0;\n}\n\n.join-us {\n  background: #000;\n  border-radius: 5px;\n  position: relative;\n  padding: 10px 43px 10px 28px;\n  display: inline-block;\n}\n\n.join-us a {\n  text-decoration: none;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.join-us a:after {\n  position: absolute;\n  content: \"\";\n  background: url(./Images/right-arrow-white.svg) no-repeat;\n  background-size: 15px;\n  width: 15px;\n  height: 15px;\n  top: 15px;\n  right: 18px;\n}\n\n.about-banner-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n@media screen and (max-width:992px) {\n  .about-banner-container {\n    text-align: center;\n  }\n}\n\n@media screen and (max-width:992px) {\n  .join-us {\n    margin-bottom: 25px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
